<template>
  <div class="link" :class="{['style'+user.iconStyle]:true, 'compact': linkFormatting.compactLinks, 'floating': linkFormatting.floating && user.account == 7, 'shake1': link.shake, 'groupMember': (link.group && !link.linkGrid) || link.site == 'Link Group' , 'groupMemberGallery': (link.group || link.site == 'Link Group') && link.site == 'Gallery Grid', 'noIcons':linkFormatting.showIcons != false, 'flat':linkFormatting.flat}" :style="{background: getBackground}">
    
    <linkinfo v-if="link.adult || link.info || link.password || link.passwordEmail || link.copyOnly" :link="link" :compact="linkFormatting.compactLinks" isSlinkView=true />

    <!-- IMAGE -->
    <div v-if="((user.account == 7 || user.enableUpgrades)) && link.site == 'Image' && link.safeSearchResults.approved" class="links" v-bind:class="{flat: linkFormatting.flat, groupLinks: link.group}" style="display:block;">
      <div style="overflow:hidden; display:flex; position:relative" v-if="link.largeIcon != true">
      <div v-if="!link.imageLink && ((link.password && (link.password != linkPassword)) || (link.passwordEmail && (!emailCollection.name && !emailCollection.email)))" @click="openPasswordPrompt('passwordPrompt')" style="top: calc((100% / 2) + 0px); z-index:1;width:100%; position:absolute;text-align:center;display: flex; justify-content: center; align-items: center;"> 
        <div style="width:100%;"><md-icon class="md-size-1x md-warn" style="justify-content:center;width:100%; color:white;text-shadow: 0px 0px 2px #000000;">lock</md-icon>
        <div style="text-transform:uppercase;color:white;text-shadow: 0px 0px 2px #000000;font-weight:bold; width:100%"><span v-if="link.unlockMessage">{{ link.unlockMessage }}</span><span v-else>unlock content</span></div></div>
      </div>
      <img v-bind:src="imageKitCDN" @click="openLink()" :id="'img'+link.id" v-bind:class="{protectedImage: (!link.imageLink && ((link.password && (link.password != linkPassword)) || (link.passwordEmail && !emailCollection.name && !emailCollection.email)))}" style="width:100%;" v-bind:style="[link.imageStyle]">
      <div v-if="link.textOverlay" @click="openLink()" class="textOverlay" v-bind:style="link.textOverlayStyle" v-html="link.textOverlay"></div>
      <div class="imageCaption" v-if="link.captionOverlay === true && (link.description || link.customdescription)" style="background: linear-gradient(180deg, transparent 0%, rgba(0,0,0, .5) 100%);
    width: 100%;
    padding: 8px 16px;
    position: absolute; bottom:0; box-shadow: unset;
    bottom: 0; display: grid; grid-template-columns: auto 20px;align-items:center" v-bind:style="{color:link.color}" @click="openLink()">
<div style="filter: drop-shadow(#000000 1px 1px 1px);">
        <div class="description" style="font-size: 16px; font-weight:bold" v-html="link.description"></div>
        <div v-html="link.customdescription"></div>
      </div>
      <img v-if="link.captionOverlayIcon" :src="link.captionOverlayIcon" style="width:20px; filter: drop-shadow(rgb(34, 34, 34) 1px 1px 1px);"/>
      <!-- <md-icon v-else md-iconset="fa fa-home fa-2xs"></md-icon> -->
      <i v-else-if="link.fa" style="filter: drop-shadow(rgb(0, 0, 0) 1px 1px 1px);" :class="link.fa +' fa-lg'"></i>
      </div>
      </div>
      <div v-if="link.largeIcon == true" class="links" v-bind:class="{flat: linkFormatting.flat, groupLinks: link.group}" style="display:flex; flex-flow:row" @click="openLink()">
     <img :src="imageKitCDN" style="width:100px; height:100px; object-fit: cover; object-position: center;"/>
     <div class="imageCaption" v-if="link.captionOverlay != true && (link.description || link.customdescription)" style="background:white; width:100%; display:flex; padding:8px 16px;flex-flow: column;justify-content:center" v-bind:style="{background:link.background, color:link.color}">
        <div class="description" style="width:100%;font-size: 16px; font-weight:bold" v-html="link.description"></div>
        <div v-html="link.customdescription"></div>
      </div>
    </div>
      <div class="imageCaption" v-if="link.largeIcon !== true && link.captionOverlay != true && (link.description || link.customdescription)" style="background:white; padding:8px 16px;" @click="openLink()" v-bind:style="{background:link.background, color:link.color}">
        <div class="description" style="font-size: 16px; font-weight:bold" v-html="link.description"></div>
        <div v-html="link.customdescription"></div>
      </div>
    </div>
    
    <!-- ############################################################################################################ -->
    <!-- <div v-else-if="((user.account != 7 || !user.enableUpgrades)) && link.site == 'Image' && link.safeSearchResults.approved" class="links" v-bind:class="{flat: linkFormatting.flat, groupLinks: link.group}" style="display:block">
    </div> -->
    <whisper-box 
      v-else-if="link.site === 'Whisper Box'" 
      :component-data="link" 
      :link-id="link.id"
      :user-id="user.key">
    </whisper-box>
    <div v-else-if="link.site=='Tweet'" class="links" v-html="link.user"></div>
    <div v-else-if="link.site === 'WNB Fight'" style="display:flex; flex-flow:column;">
      <div style="text-align:center"><h2>{{ link.user }}</h2></div>
      <div class="fightcard" v-bind:style="{'background': 'linear-gradient(90deg, '+ link.teamA.color +' ' + getVotes + '%, '+ link.teamB.color +' '+ getVotes +'%)'}" style="width:100%; display:flex; justify-content: space-between;">
        <div style="width:50%; text-align:center; color:white; font-weight:bold; text-transform:uppercase; display: flex; flex-flow:column; margin:20px 10px;" @click="vote('teamA')">
          <img :src="link.teamA.image" style="width:150px">
          {{link.teamA.name}}<br>{{link.teamA.votes}}
        </div>
        <div style="display: flex; align-items: center; font-size: xxx-large; color: white;font-weight:900">VS</div>
        <div style="width:50%; text-align:center; color:white; font-weight:bold; text-transform:uppercase; display: flex; flex-flow:column; margin:20px 10px;"  @click="vote('teamB')">
          <img :src="link.teamB.image" style="width:150px">
        {{link.teamB.name}}<br>{{link.teamB.votes}}
        </div>
      </div>
    </div>
    <div v-else-if="link.site=='KissOrSlap' || link.site == 'Random Generator'" class="links kissorslap">
      <div class="placeholder"><md-spinner :md-size="150" md-indeterminate style="stroke:white"></md-spinner></div>
      <div class="result" v-bind:style="link.styling">{{kissOrSlap}}</div>
      <div class='restart' @click="reloadPage()"><md-icon>replay</md-icon></div>
    </div>
    <div v-else-if="link.site == 'MPM Raffle'" style="display:flex; justify-content:center; align-items:center; height: auto;
    
    padding: 0px 30px;flex-flow:column;gap:10px;">
      
      <div style="background-repeat: no-repeat;
    background-image: url(https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o/userContent%2F-NIXOF6E2iMy7Xz_iyrJ%2FMPMTicket.png?alt=media&token=8a5188a4-df15-4dc3-bd13-42d8b8ccf5fa);
    font-weight: bold;
    font-size: 2em;
    line-height: 1.5em;
    aspect-ratio: 4/3;
    width: 100%;
    background-size: contain;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;">{{getRand}}</div>
      
        <div style="font-size: initial;font-weight:initial;text-align:center">Thank you for scanning the MPM Competition sticker. This is your unique code, screenshot this page and follow our Instagram account below for annoucements of the winners!</div>

<md-button  @click="resetRand()" class="md-dense">Reset Cookie</md-button>
      <!-- <div @click="resetRand()" style="font-size:initial">Reset Cookie</div> -->
    </div>
    <div v-else-if="link.site=='Treasure Hunt'" class="links treasureHunt">
      <div class="task" v-if="getQuiz && !getQuiz.answered">
      <!-- <div class="task" v-for="(question, index) in getQuiz" v-bind:key="index"  v-if="!question.answered"> -->
        <div class="question">{{getQuiz.questionNumber + 1}}. {{getQuiz.question}}</div>

          <div class="answers">
            <md-button class="md-raised md-dense rounded5 answer" v-bind:class="{'md-primary': (treasureHuntAnswer && answer.correctAnswer)}" v-for="(answer, aIndex) in getQuiz.options" v-bind:key="aIndex" @click="correctTreasureHunt(link.id, getQuiz.questionNumber, answer.correctAnswer, answer.answer)" style="max-width: 100%;
    white-space: normal;line-height:20px">{{answer.answer}}</md-button>
          </div>

          <!-- <div class="result" v-bind:class="{'unanswered': !question.result}">
            <span v-if="question.result">{{question.result}}</span>
            <span v-else>SELECT CORRECT ANSWER TO REVEAL CLUE {{ index +1}}</span>
          </div> -->
        </div>
        <!-- <div v-else>
          <img style="width:100%; border-radius:7.5px" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR6aUR4lGRtldaTMdQiC0baowL6zTV1rc9-XoHFDgeM_oyvKVBwRNwKIkQFPdKCbYKuaFA&usqp=CAU">
        </div> -->
      
        <!-- this will be the treasure hunt -->
        <div v-if="treasureHuntAnswer == true && ((treasureHuntQuestionsLeft != 0 || treasureHuntQuestionsLeft == -1) && treasureHuntQuestionsLeft != 'emailcollected')" class="correctAnswer" style="border-radius: 5px; border: 1px silver solid; padding: 8px 8px; text-align:center; color:green;  font-size:medium; font-weight:bold">Well done! Find and scan more clues to answer more questions!</div>
        <div v-else-if="treasureHuntAnswer == false" class="correctAnswer" style="border-radius: 5px; border: 1px silver solid; padding: 8px 8px; text-align:center; color:red;  font-size:medium; font-weight:bold">Incorrcet answer, please try again!</div>
        <div v-else-if="treasureHuntQuestionsLeft == 'emailcollected'" class="correctAnswer" style="border-radius: 5px; border: 1px silver solid; padding: 8px 8px; text-align:center;   font-size:medium; font-weight:bold">Let your friends and followers know you completed the MMMC Treasure Hunt, screenshot this page and tweet with #MMMCTreasureHunt</div>
        <!-- <div v-else-if="treasureHuntQuestionsLeft > 0" class="correctAnswer" style="border-radius: 5px; border: 1px silver solid; padding: 8px 8px; text-align:center; color:red;  font-size:medium; font-weight:bold">Incorrcet answer, please try again!</div> -->

        <div v-if="treasureHuntQuestionsLeft == 0" style="padding:16px">
          <img src="https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o/userContent%2F-NFrsDDHeh7pnmJwaTxl%2Falien.jpg?alt=media&token=4ccb8bdd-87b5-445e-a01c-02235e357254" style="aspect-ratio: 16/9;
    object-fit: cover;
    object-position: top;
    border-radius: 5px;margin-bottom:10px;"/>
      <div v-html="link.emailCaptureDescription"></div>
      

          <form novalidate @submit.stop.prevent="submit" autocomplete="off">
            <!-- <md-input-container class="compactContainer">
              <label>Name</label>
              <md-input required v-model="emailCollection.name"></md-input>
            </md-input-container> -->
            <md-input-container class="compactContainer">
              <label>Email</label>
              <md-input required type="email" v-model="emailCollection.email"></md-input>
            </md-input-container>
          </form>
          <md-button  class="md-primary md-raised rounded5" style="margin:unset; width:100%;" @click="collectEmail()">Ok</md-button>

          <div style="margin-top:20px;font-size:x-small; font-weight:bold; line-height:15px">By entering your name and email to access this link/content, you are consenting to your details being used for marketing purposes by the owner of this Slink page. Your information will not be used by Slink.</div>
        </div>
    </div>
    
    <div v-else-if="link.site==='Beta Debug'">
      {{ getDebugInfo() }}
    </div>
    <div v-else-if="(link.site=='Embed' || link.embed) && link.inline" class="links embeds" :id="link.id" :ref="link.id" v-html="mediaLink" style="width:100%; max-height:750px; overflow-y:auto" v-bind:style="{'height':applyAspectRatio}"></div>
    

    

    <div v-else-if="link.site=='Countdown'" class="links countdown" style="background:white; display:grid;padding:16px" v-bind:style="{background:link.background, color: link.color}" @click="openPasswordPrompt()">
    <div style="text-align:center;padding-bottom:16px;">
      <h3 v-html="link.description" style="font-size: x-large;line-height: 30px;"></h3>
      <span v-html="link.customdescription"></span>
    </div>

      <flip-countdown :deadline="getDeadline"></flip-countdown>
      <div v-if="link.showDeadline != false" style="text-align:center;padding-top:16px">{{getDisplayDeadline}}</div>
      </div>
    <div v-else-if="link.site=='Carousel'" class="links" style="overflow:hidden">
      <div class="imageCaption" v-if="link.hideLabel != true && (link.description || link.customdescription) && link.labelTop" style="padding:8px 16px 0 16px;" v-bind:style="{background: link.background, color:link.color}">
        <div class="description" style="font-weight:bold; font-size:16px;" v-html="link.description"></div>
        <div v-html="link.customdescription"></div>
      </div>
      
      <!-- <div class="title">{{link.description}}</div> --><div :id="link.autoslide ? 'autoslider':'static'" style="padding:8px 16px 0 16px;" class="carousel content" v-bind:class="{'autoslide': link.autoslide}" v-bind:style="[link.carouselStyle, {background:link.background, animationDuration: sliderDuration + 's'}]">
        <figure v-for="(image, index) in getImages" v-if="link.images && image.visible != false" v-bind:key="image.id" @click="openCarouselLink(image.url, image.id, link.id)" style="height:auto; background:#ffffff" v-bind:style="[link.itemStyling, {'width': getCarouselImageWidth}]">
        <img v-if="image.video != true && image.content != true" :id="link.id+'_'+index" :src="image.source" :alt="image.label" loading="lazy" v-bind:style="[{width: getCarouselImageWidth, height: getImageHeight(link.id+'_'+index), aspectRatio: link.aspectRatio},link.style, image.style, link.imageStyling]">
        <iframe v-else-if="image.content != true && image.video == true && image.autoplay != true" :src="image.source" loading="lazy" style="aspect-ratio:16/9;" v-bind:style="[link.imageStyling, image.style]"></iframe>
        <video v-else-if="image.content != true && image.video == true && image.autoplay == true" autoplay muted loop playsinline :src="image.source" loading="lazy" style="aspect-ratio:16/9;border-radius: 7px;" v-bind:style="[link.imageStyling, image.style]"></video>
        <div v-else-if="image.content" v-html="image.source" v-bind:style="[link.imageStyling, image.style]"></div>
        <figcaption v-if="image.label || image.description" v-bind:class="{'overlay': link.imageOverlay}">
          <div v-if="image.label" v-html="image.label" style="font-size:16px; font-weight:bold" v-bind:style="link.itemStyling"></div>
          <div v-if="image.description" style="font-size:14px; font-weight:normal" v-html="image.description" v-bind:style="link.itemStyling"></div>
        </figcaption>
      </figure>
      
      <!-- <figure v-for="(image, index) in getImages" v-if="link.images && image.visible != false && link.autoslide" v-bind:key="image.id +'#2'" @click="openCarouselLink(image.url, image.id, link.id)" style="height:auto; background:#ffffff" v-bind:style="[link.itemStyling, {'width': getCarouselImageWidth}]">
        <img v-if="image.video != true && image.content != true" :id="link.id+'_'+index" :src="image.source" :alt="image.label" loading="lazy" v-bind:style="[{width: getCarouselImageWidth, height: getImageHeight(link.id+'_'+index), aspectRatio: link.aspectRatio},link.style, image.style, link.imageStyling]">
        <iframe v-else-if="image.content != true && image.video == true && image.autoplay != true" :src="image.source" loading="lazy" style="aspect-ratio:16/9;" v-bind:style="[link.imageStyling, image.style]"></iframe>
        <video v-else-if="image.content != true && image.video == true && image.autoplay == true" autoplay muted loop playsinline :src="image.source" loading="lazy" style="aspect-ratio:16/9;border-radius: 7px;" v-bind:style="[link.imageStyling, image.style]"></video>
        <div v-else-if="image.content" v-html="image.source" v-bind:style="[link.imageStyling, image.style]"></div>
        <figcaption v-if="image.label || image.description">
          <div v-if="image.label" v-html="image.label" style="font-size:16px; font-weight:bold" v-bind:style="link.itemStyling"></div>
          <div v-if="image.description" style="font-size:14px; font-weight:normal" v-html="image.description" v-bind:style="link.itemStyling"></div>
        </figcaption>
      </figure> -->
      <figure v-for="(yt, index) in link.youtube" v-if="link.youtube && yt.visible != false" v-bind:key="index">
        <iframe :src="yt.source" loading="lazy" style="aspect-ratio:16/9;height: 175px; border-radius: 7px;"></iframe>
        <figcaption v-if="yt.label || yt.description"><span v-if="yt.label" v-html="yt.label"></span>
          <br v-if="yt.label && yt.description" style="margin-top:10px">
          <span v-if="yt.description" style="font-size:14px; font-weight:normal" v-html="yt.description"></span>
        </figcaption>
      </figure>
      <figure v-for="(content, index) in link.content" v-if="link.content && content.visible != false" v-bind:key="index">
        <div v-html="content.source" v-bind:style="content.style"></div>
        <figcaption v-if="content.label || content.description" style="font-size:initial">
          <div v-if="content.label" v-html="content.label"></div>
          <div v-if="content.description" style="font-size:14px; font-weight:normal" v-html="content.description"></div>
        </figcaption>
      </figure>
      <!-- <div v-if="link.autoslide" v-bind:cl ass="{'autoslideFade': link.autoslide}"></div> -->

      </div>
      <div class="imageCaption" v-if="link.hideLabel != true && (link.description || link.customdescription) && link.labelTop !== true" style="background:white; padding:8px 16px;" v-bind:style="{background:link.background, color:link.color}">
        <div class="description" style="font-weight:bold; font-size:16px;" v-html="link.description"></div>
        <div v-html="link.customdescription"></div>
      </div>
      
    </div>
    
    <div v-else-if="link.site=='Gallery Grid'" class="links" v-bind:class="{caption: link.showLabel}">
      
      <div class="galleryGrid" v-bind:class="{caption: link.showLabel, col1: link.col == 1, col2: link.col == 2, col3: link.col == 3, col4: link.col == 4}" v-bind:style="link.galleryStyle"> 

      
        <div v-for="(image, index) in getImages" v-bind:key="index" v-if="image.visible != false">
      <figure   v-if="image.visible != false && image.source !=undefined && !image.popOut"  @click="openCarouselLink(image.url, image.id, link.id)" v-bind:style="{background:link.background, color: link.color}" v-bind:class="{'shake':image.shake}">
        <div style="position: relative; display: block;">
          <img v-if="image.content != true":id="link.id+'_'+index" :src="image.source" :alt="image.label" loading="lazy" v-bind:style="[link.imageStyling, image.imageStyling, {height: getImageHeight(link.id+'_'+index)}]">
          <div v-else v-html="image.source" style="display:flex; " v-bind:style="[link.imageStyling]"></div>
          <div v-if="link.overlay" style="position: absolute;padding:16px; width: 100%; top: 0; height: 100%; display: flex; flex-flow: column; justify-content: center; align-items: center; color: white; background: rgba(0, 0, 0, 0.1);">
            <div v-if="image.label" style="text-align:center; text-wrap: balance; font-weight:bold; filter: drop-shadow(rgb(34, 34, 34) 2px 2px 4px);text-transform:uppercase" v-html="image.label"></div>
            <div v-if="image.description" style="font-size:10px; text-wrap: balance; filter: drop-shadow(rgb(34, 34, 34) 2px 2px 4px);line-height:normal; font-weight:normal" v-html="image.description"></div>
          </div>
        </div>
        <figcaption v-if="(image.label || image.description) && link.overlay != true" style="font-size:initial">
          <div v-if="image.label" v-html="image.label"></div>
          <div v-if="image.description" style="font-size:14px; font-weight:normal" v-html="image.description"></div>
        </figcaption>
      </figure>

      <figure v-else-if="image.popOut && image.cover"  @click="openContent(image.label, image.source, image.style)" v-bind:style="{background:link.background, color: link.color}" v-bind:class="{'shake':image.shake}">
        <div style="position: relative; display: block;">
          <img v-if="image.content != true":id="link.id+'_'+index" :src="image.cover" :alt="image.label" loading="lazy" v-bind:style="[link.imageStyling, image.imageStyling, {height: getImageHeight(link.id+'_'+index)}]">
          <div v-else v-html="image.source" style="display:flex; " v-bind:style="[link.imageStyling]"></div>
          <div v-if="link.overlay" style="position: absolute;padding:16px; width: 100%; top: 0; height: 100%; display: flex; flex-flow: column; justify-content: center; align-items: center; color: white; background: rgba(0, 0, 0, 0.1);">
            <div v-if="image.label" style="text-align:center; text-wrap: balance; font-weight:bold; filter: drop-shadow(rgb(34, 34, 34) 2px 2px 4px);text-transform:uppercase" v-html="image.label"></div>
            <div v-if="image.description" style="font-size:10px; text-wrap: balance; filter: drop-shadow(rgb(34, 34, 34) 2px 2px 4px);line-height:normal; font-weight:normal" v-html="image.description"></div>
          </div>
        </div>
        <figcaption v-if="(image.label || image.description) && link.overlay != true" style="font-size:initial">
          <div v-if="image.label" v-html="image.label"></div>
          <div v-if="image.description" style="font-size:14px; font-weight:normal" v-html="image.description"></div>
        </figcaption>
      </figure>
      
      <div v-else-if="image.popOut == true && !image.cover" style="display:flex; height:100%; align-items: center; justify-content: center; text-transform: capitalize; width:100%; text-align:center; font-size:16px; font-weight:bold; background:white; padding:8px; border-radius:10px; box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 5px 8px rgba(0, 0, 0, 0.14), 0 1px 14px rgba(0, 0, 0, 0.12);" @click="openContent(image.label, image.source, image.style)">{{ image.label}}</div>
      <!-- <div v-else-if="image.popOut == true && image.cover !== true" v-for="(image, index) in getImages" v-bind:key="index" style="display:flex; align-items: center; justify-content: center; text-transform: capitalize; width:100%; text-align:center; font-size:16px; font-weight:bold; background:white; padding:8px; border-radius:10px; box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 5px 8px rgba(0, 0, 0, 0.14), 0 1px 14px rgba(0, 0, 0, 0.12);" @click="openContent(image.label, image.source)">{{ image.label}}</div> -->
    
    </div>
      
    </div>
    <div class="imageCaption" v-if="link.showLabel == true && (link.description || link.customdescription) && link.labelTop !== true" style="background:white; padding:8px 16px;" v-bind:style="{background:link.background, color:link.color}">
        <div class="description" style="font-weight:bold; font-size:16px;" v-html="link.description"></div>
        <div v-html="link.customdescription"></div>
      </div>
    </div>
    
    

    <div v-else-if="link.site == 'Slink Referral'" @click="openLink()" style="font-weight:bold; text-align:center; padding:10px 10px 20px 10px;vertical-align: middle; font-size: x-small; text-transform: uppercase;">
         Get your own Slink page
    </div>


    <!-- INLINE TEXT BLOCK --> <!-- NEEDS PASSWORD -->
    <div v-else-if="((user.account == 7 || user.enableUpgrades)) && link.inline && link.site == 'Text Block' && !link.groupIcon" class="content" style="padding-left:16px; padding-right:16px; padding-top:10px; padding-bottom:10px;" v-html="link.user" v-bind:style="[link.styling, {color:link.color}]"></div>
    <div v-else-if="((user.account == 7 || user.enableUpgrades)) && link.inline && link.site == 'Text Block' && link.groupIcon" class="links embeds" :id="link.id" :ref="link.id" style="width:100%; max-height:750px; overflow-y:auto" v-bind:style="{'height':applyAspectRatio}">
      <div class="link">
      <div v-if="linkFormatting.showIcons != true" class="icon" v-bind:style="{background: link.background}">
        <siteicon v-if="!user.showIcons" :account="parseInt(user.account)" :enableUpgrades="user.enableUpgrades" :link="link" :compact="linkFormatting.compactLinks" :iconStyle="user.iconStyle" />
      </div>
      <div class="text" v-bind:style="{color: getTextColour}">
        <div class="title" v-bind:style="{color: getTextColour}" v-if="link.description" v-html="link.description"></div>
        <div class="title" v-bind:style="{color: getTextColour}" v-else>{{link.site}}</div>
        <div class="description" v-bind:style="{color: getTextColour}" v-if="link.customdescription" v-html="link.customdescription"></div>
        </div>
        </div>
      <div v-html="mediaLink" />  
    </div>
    <!-- <div v-else-if="((user.account == 7 || user.enableUpgrades)) && link.inline && link.site == 'Text Block'" class="content" style="padding-left:16px; padding-right:16px; padding-top:10px; padding-bottom:10px;" v-html="link.user" v-bind:style="[link.styling, {background:link.background, color:link.color}]"></div> -->

    <!-- INLINE EMBED --> <!-- NEEDS PASSWORD -->
    <div v-else-if="((user.account == 7 || user.enableUpgrades)) && link.site != 'Link Group' && linkFormatting.media == true && (link.inline ||(!link.inline && link.group))" style="width:100%" v-bind:style="{background:link.background}">
      <div class="test">
      <div v-if="(link.password && (link.password != linkPassword)) || (link.passwordEmail && !link.imageLink && !emailCollection.name && !emailCollection.email)" @click="openPasswordPrompt('passwordPrompt')" style="height:100%; z-index:1;width:100%; position:absolute;text-align:center;display: flex; justify-content: center; align-items: center;"> 
        <div style="width:100%;"><md-icon class="md-size-1x md-warn" style="justify-content:center;width:100%; color:white;text-shadow: 0px 0px 2px #000000;">lock</md-icon>
        <div style="text-transform:uppercase;color:white;text-shadow: 0px 0px 2px #000000;font-weight:bold; width:100%">unlock content</div></div>
      </div>
      <!-- <div v-if="link.site=='Embed'">test</div> -->
      <div v-if="link.site == 'Video Player'" @click="openLink()" >
        <video v-if="link.site == 'Video Player'" loop controlsList="nodownload" playsinline v-bind:controls="!link.imageLink" v-bind:muted="link.autoplay" v-bind:autoplay="link.autoplay" :poster="link.videoPoster" style="border-radius:0px;object-fit: cover; object-position: center;width:100%" v-bind:style="{background: link.background, 'height':applyAspectRatio}">
          <source :src="mediaLink" type="video/mp4">
          Your browser does not support the video tag.
        </video>
        
        <div class="imageCaption" v-if="link.description || link.customdescription" style="background:white; padding:8px 16px;" @click="openLink()" v-bind:style="{background:link.background, color:link.color}">
          <div class="description" style="font-weight:bold" v-html="link.description"></div>
          <div v-html="link.customdescription"></div>
        </div>
      </div>
      <div v-else-if="link.site=='Personal Statistics' || link.site=='Opening Times'" class="personalStats">
          <div style="text-align:center; padding:5px;font-weight:bold; text-transform: uppercase;">{{link.description}}</div>
          <div v-for="(stat, index) in link.user" v-bind:key="index" class="row">
            <div class="header" style="">{{index}}:</div>
            <div class="stat">{{stat}}</div>
          </div>
        </div>
      <iframe class="inlineIframe" v-else-if="link.site != 'Gallery'" loading="lazy" :id="link.id" :ref="link.id" width="100%"  v-bind:class="{[link.site.replace(/\s/g, '')]:linkFormatting.media, protectedImage: (link.password && (link.password != linkPassword)) || (link.passwordEmail && !emailCollection.name && !emailCollection.email)}" :src="mediaLink" frameborder="0" allow="autoplay; encrypted-media" style="width:100%; " v-bind:style="{background: link.background, 'height':applyAspectRatio}"></iframe>
      <!-- <div v-else-if="link.site=='Gallery'" class="9cube links"  v-bind:style="{background: getBackground}" style="width:100%; display:flex; flex-wrap:wrap;justify-content: start;">
        <div v-if="link.description" style="font-size:16px; padding:8px 16px; width:100%; border-bottom:1px whitesmoke solid">
          <div style="width:100%; font-weight:bold;" v-html="link.description"></div>
          <div v-if="link.customdescription" style="font-size:14px; width:100%" v-html="link.customdescription"> </div>
        </div>
        <div style="width:100%; display:flex; flex-wrap:wrap;justify-content: start; " v-bind:style="{background: link.background}">
          <div v-if="link.title" style="width:100%; font-weight:bold; font-size:16px; padding: 5px 20px; " v-bind:style="{color:link.color}">{{link.title}}</div>
          <img v-if="link.linkOnly == true" v-for="(image, index) in link.images" v-bind:key="index" :src="imageKit(image.source,'9cubethumb')" style="object-fit:cover;width:33.33%;aspect-ratio:1/1" :id="'9cubeThumb' + index" @click="openGalleryLink(image.url)" >
          <img v-if="link.linkOnly == false || link.linkOnly == undefined" v-for="(image, index) in link.images" v-bind:key="index" :src="imageKit(image.source,'9cubethumb')" style="object-fit:cover;width:33.33%;aspect-ratio:1/1" :id="'9cubeThumb' + index" v-bind:style="{ height: mediaHeight('9cubeThumb'+index, 'galleryThumb', image.source) }" @click="openImage(image)">
        </div>
      </div> -->
      <div v-if="link.title" style="padding:8px 16px; margin-left:0px" v-bind:style="{backgroundColor: link.titleBG, color:getTextColour}">
        <h3 v-bind:style="{color: getTextColour}" style="padding:unset" v-html="link.description"></h3>
        <div v-html="link.customdescription"></div>
      </div>
      </div>
      <div v-if="link.embedText && (link.description || link.customdescription)" class="text" style="padding: 8px 16px;  background:white;" v-bind:style="{color: getTextColour}">
        <div class="title" style="font-size: 16px; font-weight:bold" v-bind:style="{color: getTextColour}" v-if="link.description" v-html="link.description"></div>
        <div class="description" v-bind:style="{color: getTextColour}" v-if="link.customdescription" v-html="link.customdescription"></div>
        </div>
    </div>


    <!-- TABBED CONTENT -->
              <!-- <md-tabs v-if="link.site == 'Tabbed Content'" md-fixed style="background:white" class="md-transparent links" >
                <md-tab v-for="(tab, index) in link.tabs" v-bind:key="index" :md-label="tab.label">
                  <p v-html="tab.info" style="margin:unset"></p>
                </md-tab>
              </md-tabs> -->

    <!-- LINK WITH MEDIA EXPAND -->  <!-- NEEDS PASSWORD -->
    <details class="link" v-else-if="link.site != 'Image' && linkFormatting.media && !link.group && link.site !='Link Group'" v-bind:style="{background:getBackground, color: getTextColour}" style="">
    <!-- <details class="link" v-else-if="link.site != 'Image' && linkFormatting.media && !link.group && link.site !='Link Group'" v-bind:style="{background:getBackground, color: getTextColour}" style="padding: 8px 0px 8px 8px;"> -->

  <summary :id="link.id" style="min-height: 56px;gap: 12px; ">
    <div style="display: grid !important;
    grid-template-columns: 80px auto 40px;
    min-height: 80px;
    row-gap: 12px;
    column-gap: 12px;" class="container"><div class="icon">
      <siteicon v-if="!user.showIcons" :account="parseInt(user.account)" :enableUpgrades="user.enableUpgrades" :link="link" :compact="linkFormatting.compactLinks" :iconStyle="user.iconStyle" />
    </div>
    <div class="text" v-bind:style="{color: getTextColour}">
        <div class="title" v-if="link.description" v-html="link.description"></div>
        <div class="title" v-else>{{link.site}}</div>
        <div class="description" v-if="link.customdescription" v-html="link.customdescription"></div>
    </div>
    <div class="chevron" style="padding-top:16px">
                      <md-icon class="more">expand_more</md-icon>
                      <md-icon class="less">expand_less</md-icon>
                    </div>
    </div>
  </summary>

    <div v-if="link.site == 'Text Block'" v-bind:style="[link.styling, {background: getBackground}]" style="background-color:white;padding-top:10px; padding-bottom:10px;padding-left:20px; padding-right:20px; border-bottom:1px solid silver"  v-html="link.user"></div>
    <div v-else-if="link.bindHTML" :id="link.id" :ref="link.id" v-bind:class="link.site.replace(/\s/g, '')" v-bind:style="{background: getBackground, height:applyAspectRatio}" style="background-color:white; border-bottom:1px solid silver; overflow:hidden;" v-html="link.user"></div>
        
        <div v-else-if="link.site=='Personal Statistics' || link.site=='Opening Times'" class="personalStats">
          <!-- test -->
          <div v-for="(stat, index) in link.user" v-bind:key="index" class="row">
            <div class="header" style="">{{index}}:</div>
            <div class="stat">{{stat}}</div>
          </div>
        </div>
        <!-- <span v-else-if="link.site == 'TikTok Player'" :id="'media'+link.id" :ref="link.id" width="100%" v-bind:class="link.site.replace(/\s/g, '')" v-html="link.user" frameborder="0" allow="encrypted-media" style="width:100%; background:white" v-bind:style="{'height': applyAspectRatio}"></span> -->
        <iframe v-else :id="'media'+link.id" :ref="link.id" loading="lazy" width="100%" v-bind:class="link.site.replace(/\s/g, '')" :src="mediaLink" frameborder="0" allow="encrypted-media" style="width:100%; background:white" v-bind:style="{'height': applyAspectRatio}"></iframe>
</details>


    <!-- <details class="link" v-else-if="link.site != 'Image' && linkFormatting.media && !link.group && link.site !='Link Group'" v-bind:style="{background:getBackground, color: getTextColour}" style="padding: 8px 0px 8px 8px;">

  <summary :id="link.id" style="display:grid; grid-template-columns: 56px auto 40px;
    min-height: 56px;gap: 12px;">
    <div class="icon">
      <siteicon v-if="!user.showIcons" :account="parseInt(user.account)" :enableUpgrades="user.enableUpgrades" :link="link" :compact="linkFormatting.compactLinks" :iconStyle="user.iconStyle" />
    </div>
    <div class="text" v-bind:style="{color: getTextColour}">
        <div class="title" v-if="link.description" v-html="link.description">{{link.site}}</div>
        <div class="title" v-else>{{link.site}}</div>
        <div class="description" v-if="link.customdescription">{{link.customdescription}}</div>
    </div>
  </summary>
    <div v-if="link.site == 'Text Block'" v-bind:style="{background: getBackground}" style="background-color:white;padding-top:10px; padding-bottom:10px;padding-left:20px; padding-right:20px; border-bottom:1px solid silver" v-html="link.user"><md-divider></md-divider></div>
        <div v-if="link.bindHTML" :id="link.id" :ref="link.id" v-bind:class="link.site.replace(/\s/g, '')" v-bind:style="{background: getBackground, height:applyAspectRatio}" style="background-color:white; border-bottom:1px solid silver; overflow:hidden;" v-html="link.user"></div>
        
        <div v-if="link.site=='Personal Statistics' || link.site=='Opening Times'" class="personalStats">
          <div v-for="(stat, index) in link.user" v-bind:key="index" v-if="stat" class="row">
            <div class="header" style="">{{index}}:</div>
            <div class="stat">{{stat}}</div>
          </div>
        </div>
        <iframe v-else :id="'media'+link.id" :ref="link.id" width="100%" v-bind:class="link.site.replace(/\s/g, '')" :src="mediaLink" frameborder="0" allow="autoplay; encrypted-media" style="width:100%; background:white" v-bind:style="{'height': applyAspectRatio}"></iframe>
</details> -->


<!-- <div v-else class="link" :disabled="link.site == 'Link Group'" :class="{}" v-bind:style="{background:getBackground}" @click="if(link.site != 'Link Group'){openLink()}">
      <div class="icon">
        <siteicon v-if="!user.showIcons" :account="parseInt(user.account)" :enableUpgrades="user.enableUpgrades" :link="link" :compact="linkFormatting.compactLinks" :iconStyle="user.iconStyle" />
      </div>
      <div class="text" v-bind:style="{color: getTextColour}">
        <div class="title" v-if="link.description" v-html="link.description">{{link.site}}</div>
        <div class="title" v-else>{{link.site}}</div>
        <div class="description" v-if="link.customdescription">{{link.customdescription}}</div>
        </div>
      
    </div> -->



    <!-- <md-list-item v-else-if="link.site != 'Image' && linkFormatting.media && !link.group && link.site !='Link Group'" class="links linksWithExpand standardLink" v-bind:class="{flat: linkFormatting.flat, groupLinks: link.group || link.site == 'Link Group', compactLinks: linkFormatting.compactLinks, iconStyle1: user.iconStyle==1, iconStyle2: user.iconStyle==2, [link.site.replace(/\s/g, '')]:linkFormatting.media}" v-bind:style="{background: getBackground}">
      <siteicon v-if="!linkFormatting.showIcons && link.site != 'Link Group'" :account="parseInt(user.account)" :enableUpgrades="user.enableUpgrades" :link="link" :compact="linkFormatting.compactLinks" :iconStyle="user.iconStyle"/>
      <div class="md-list-text-container" v-bind:class="{textAlign: linkFormatting.showIcons, hideIconEmbed: linkFormatting.showIcons}">
        <h3 v-bind:style="{color: getTextColour}">
          <span v-if="link.description" >{{ link.description }}</span>
          <span v-else >{{link.site}}</span>
        </h3>
        <span v-if="parseInt(user.account) == 7 && link.customdescription" v-bind:style="{color: getTextColour}" style="position: relative;white-space: pre-line;">{{ link.customdescription }}</span>
      </div>
      <md-button v-if="link.qrcode" class="md-icon-button" v-bind:style="{color: getTextColour}" @click="openQRDialog(link.site, link.base, link.user, link.suffix);">
        <md-icon>qr_code_2</md-icon>
      </md-button>
      <md-list-expand style="background:none; width:100%" v-bind:class="link.site.replace(/\s/g, '')">
        <div v-if="link.site == 'Text Block'" v-bind:style="{background: getBackground}" style="background-color:white;padding-top:10px; padding-bottom:10px;padding-left:20px; padding-right:20px; border-bottom:1px solid silver" v-html="link.user"><md-divider></md-divider></div>
        <div v-if="link.bindHTML" :id="link.id" :ref="link.id" v-bind:class="link.site.replace(/\s/g, '')" v-bind:style="{background: getBackground, height:applyAspectRatio}" style="background-color:white; border-bottom:1px solid silver; overflow:hidden;" v-html="link.user"></div>
        
        <div v-if="link.site=='Personal Statistics' || link.site=='Opening Times'" class="personalStats">
          <div v-for="(stat, index) in link.user" v-bind:key="index" v-if="stat" class="row">
            <div class="header" style="">{{index}}:</div>
            <div class="stat">{{stat}}</div>
          </div>
        </div>
        <iframe v-else :id="link.id" :ref="link.id" width="100%" v-bind:class="link.site.replace(/\s/g, '')" :src="mediaLink" frameborder="0" allow="autoplay; encrypted-media" style="width:100%; background:white" v-bind:style="{'height': applyAspectRatio}"></iframe>
      </md-list-expand>
      <md-divider></md-divider>
    </md-list-item> -->




    <!-- CAPTURE PREMIUM FEATURES WITH NO SUBSCRIPTION -->
    <!-- <div v-if="link.inline && (user.account != 7 || !user.enableUpgrades) && link.site == 'Image'"></div> -->

    <!-- STANDARD LINKS -->
    <!-- <md-list-item v-else class="links standardLink" :disabled="link.site == 'Link Group'" v-bind:class="{clear: linkFormatting.clearLinks, flat: linkFormatting.flat, groupLinks: link.group || link.site == 'Link Group', compactLinks: linkFormatting.compactLinks, iconStyle1: user.iconStyle==1, iconStyle2: user.iconStyle==2}" v-bind:style="{background: getBackground}" @click="openLink()">
      <siteicon v-if="!linkFormatting.showIcons && (link.site != 'Link Group' || link.site =='Link Group' && link.groupIcon) " :account="parseInt(user.account)" :enableUpgrades="user.enableUpgrades" :link="link" :compact="linkFormatting.compactLinks" :iconStyle="user.iconStyle" />
      <div class="md-list-text-container" v-bind:class="{textAlign: linkFormatting.showIcons, groupHeader: (link.site =='Link Group' && (!link.groupIcon && link.groupIcon != undefined))}">
        <h3 v-bind:style="{color: getTextColour}">
          <span v-if="link.site == 'Link Group'">{{ link.user }}</span>
          <div v-else-if="link.description" v-html="link.description"></div>
          <span v-else >{{link.site}}</span>
        </h3>
        <span v-if="parseInt(user.account) == 7 && link.customdescription" v-bind:style="{color: getTextColour}" style="position: relative;white-space: pre-line;" v-html="link.customdescription">{{ link.customdescription }}</span>
      </div>
      <md-button v-if="link.qrcode" class="md-icon-button" style="margin:unset" v-bind:style="{color: getTextColour}" @click="openQRDialog(link.site, link.base, link.user, link.suffix, link.site);">
        <md-icon>qr_code_2</md-icon>
      </md-button>
    </md-list-item> -->

    <div v-else-if="link.site == 'CoreApesCalculator'" style="display:grid;gap: 10px; padding:10px;grid-template-columns: repeat(2, minmax(0, 1fr));">
      <div style="grid-column: 1 / 3; text-align:center; font-weight:bolder; font-size:x-large; line-height:initial;padding:5px;">RARITY<br>{{((Number(rarity.outfit) + Number(rarity.eyes) + Number(rarity.mouth) + Number(rarity.headwear) + Number(rarity.skin) + Number(rarity.background))*100000).toFixed(4)}}</div>
      <!-- <div>{{link.nft.totalCollection}}</div>  -->
      <md-input-container v-if="user.beta" v-for="(nftProperty, index) in link.nft.properties" v-bind:key="index" style="margin:unset">
        <label :for="index">{{index}}</label>
        <md-select :name="index" :id="index" v-model="rarity[index]">
          <md-option v-for="(property, index) in nftProperty" v-bind:key="index" :value="[index,property]">{{index }}</md-option>
        </md-select>
        
      <!-- <md-option value="{'property':'Bubblegum', 'value': 0.00000336768370714623">Bubblegum</md-option> -->
        <!-- {{index}} -->
      </md-input-container>
      <!-- <md-option value="{'property':'Bubblegum', 'value': 0.00000336768370714623">Bubblegum</md-option> -->

       <md-input-container style="margin:unset">
        <label for="background">Background</label>
        <md-select name="background" id="background" v-model="rarity.background">
          <md-option value='0.00000336768370714623'>Bubblegum</md-option>
          <md-option value='0.00000365737692926633'>Bubblez</md-option>
          <md-option value='0.0000041734485205125'>Cloudy</md-option>
          <md-option value='0.000003932208721638940'>Creamy</md-option>
          <md-option value='0.0000111520017843203'>Matcha Lime</md-option>
          <md-option value='0.0000027994736989446'>Mellow Yellow</md-option>
          <md-option value='0.000680272108843537'>Nebula</md-option>
          <md-option value='0.00000303692905733722'>Sky Blue</md-option>
          <md-option value='0.00000313489451079971'>Tangerine</md-option>
        </md-select>
      </md-input-container>

      <md-input-container style="margin:unset">
        <label for="skin">Skin</label>
        <md-select name="skin" id="skin" v-model="rarity.skin">
          <md-option value='0.00000666933440042684'>Blanco</md-option>
          <md-option value='0.00000402527875055348'>Brownee</md-option>
          <md-option value='0.0000125976316452507'>Diamond</md-option>
          <md-option value='0.00000701311452416018'>Drippy Pink</md-option>
          <md-option value='0.0000755857898715042'>Gold</md-option>
          <md-option value='0.00000562208354416147'>Green Coreum Fur</md-option>
          <md-option value='0.00000629881582262535'>Gummy</md-option>
          <md-option value='0.00000586441473140981'>I Am Root</md-option>
          <md-option value='0.00000647878198898607'>Inferno</md-option>
          <md-option value='0.00000800320128051221'>Metallic</md-option>
          <md-option value='0.00000641766140418432'>Midnight</md-option>
          <md-option value='0.00000883470271225373'>Phoenix</md-option>
          <md-option value='0.00000680272108843538'>Radioactive</md-option>
          <md-option value='0.00000773036487322202'>Syrup</md-option>
          <md-option value='0.0000115300357431108'>Trippy Eyez</md-option>
          <md-option value='0.00000919286633572348'>X Ray</md-option>
        </md-select>
      </md-input-container>


      <md-input-container style="margin:unset">
        <label for="outfit">Outfit</label>
        <md-select name="outfit" id="outfit" v-model="rarity.outfit">
          <md-option value='0.0000113378684807256'>Beez</md-option>
          <md-option value='0.000018896447467876'>Black Cult Robe</md-option>
          <md-option value='0.00001214771622934890'>Blue Ripped Tee</md-option>
          <md-option value='0.0000100040016006403'>Blue Striped Tee</md-option>
          <md-option value='0.000010972130787799'>Blue Tanky</md-option>
          <md-option value='0.00001333866880085370'>Blue Varsity</md-option>
          <md-option value='0.000010465724751439'>Coreum Hoodie</md-option>
          <md-option value='0.000014172335600907'>Dark Trippy Puffer</md-option>
          <md-option value='0.0000309214594928881'>Gold Cult Robe</md-option>
          <md-option value='0.0000130821559392988'>Gold Scarf</md-option>
          <md-option value='0.00001000400160064030'>Green Scarf</md-option>
          <md-option value='0.00001236858379715520'>Jade Headphonez</md-option>
          <md-option value='0.000013883104262113'>Kimono</md-option>
          <md-option value='0.0000106292517006803'>Maroon Ripped Tee</md-option>
          <md-option value='0.000021944261575598'>Metallic Cult Robe</md-option>
          <md-option value='0.00001115200178432030'>Naked</md-option>
          <md-option value='0.0000170068027210884'>Overallz</md-option>
          <md-option value='0.000010307153164296'>Purple Varsity</md-option>
          <md-option value='0.0000123685837971552'>Red Scarf</md-option>
          <md-option value='0.0000234576589256392'>Suspenders</md-option>
          <md-option value='0.0000133386688008537'>Tangy Headphonez</md-option>
          <md-option value='0.0000111520017843203'>Trippy Kimono</md-option>
          <md-option value='0.0000174428745857317'>Trippy Puffer</md-option>
          <md-option value='0.000014172335600907'>Trippy Space Suit</md-option>
          <md-option value='0.0000130821559392988'>Tye Dye</md-option>
          <md-option value='0.0000090702947845805'>Web3 Geek</md-option>
          <md-option value='0.0000121477162293489'>White Coreum Hoodie</md-option>
          <md-option value='0.0000136054421768707'>Windbreaker</md-option>
        </md-select>
      </md-input-container>

      <md-input-container style="margin:unset">
        <label for="eyes">Eyes</label>
        <md-select name="eyes" id="eyes" v-model="rarity.eyes">
          <md-option value='0.0000242954324586978'>3D Glasses</md-option>
          <md-option value='0.0000123685837971552'>Aviatorz</md-option>
          <md-option value='0.00001236858379715520'>Blue Eye Glasses</md-option>
          <md-option value='0.00000731475385853266'>Blue Eyes</md-option>
          <md-option value='0.000010465724751439'>Blue Laser</md-option>
          <md-option value='0.00000723693732812274'>Coreum Laser</md-option>
          <md-option value='0.0000106292517006803'>Eye Glasses Swirl</md-option>
          <md-option value='0.0000121477162293489'>Flamez</md-option>
          <md-option value='0.00000958129730765546'>Flower Shadez</md-option>
          <md-option value='0.0000251952632905014'>Gold Shades</md-option>
          <md-option value='0.00001259763164525070'>Green Eye Glasses</md-option>
          <md-option value='0.0000090702947845805'>Green Eyes</md-option>
          <md-option value='0.0000119345984007638'>Green Swirl</md-option>
          <md-option value='0.00001214771622934890'>Los Muertos</md-option>
          <md-option value='0.0000101533150573662'>Nuclear Eyes</md-option>
          <md-option value='0.0000144738746562455'>Orange Slices</md-option>
          <md-option value='0.000021944261575598'>Pit Vipers</md-option>
          <md-option value='0.000012147716229348900'>Rabid</md-option>
          <md-option value='0.000020614306328592'>Rainbow Shadez</md-option>
          <md-option value='0.0000107979699816435'>Red Alert</md-option>
          <md-option value='0.0000170068027210884'>Scuba</md-option>
          <md-option value='0.0000125976316452507'>Squint</md-option>
          <md-option value='0.0000117288294628196'>Static</md-option>
          <md-option value='0.00000931879601155531'>Third Eye</md-option>
          <md-option value='0.0000425170068027211'>VR</md-option>
          <md-option value='0.00000829600132736021'>Wired</md-option>
        </md-select>
      </md-input-container>
      <md-input-container style="margin:unset">
        <label for="headwear">Headwear</label>
        <md-select name="headwear" id="headwear" v-model="rarity.headwear">
          <md-option value='0.000680272108843537'>#1</md-option>
          <md-option value='0.00000647878198898607'>Banana Split</md-option>
          <md-option value='0.00000635768326021998'>Black Snapback</md-option>
          <md-option value='0.00000618429189857761'>Blue Beanie</md-option>
          <md-option value='0.00000660458358100522'>Brain Matter</md-option>
          <md-option value='0.000015460729746444'>Gold Coreum Cap</md-option>
          <md-option value='0.00000687143544286402'>Green Training Band</md-option>
          <md-option value='0.0000147885241052943'>Mad Hatter</md-option>
          <md-option value='0.00000281104177208073'>None</md-option>
          <md-option value='0.00000562208354416147'>Pooty Cap</md-option>
          <md-option value='0.00000701311452416018'>Solar System</md-option>
          <md-option value='0.00000602010715790741'>Trippy Beanie</md-option>
          <md-option value='0.0000123685837971552'>Trippy Cowboy</md-option>
          <md-option value='0.00000731475385853266'>Trippy Training Band</md-option>
          <md-option value='0.00000781921964187974'>Trippy Turd</md-option>
          <md-option value='0.0000144738746562455'>Trippy Viking</md-option>
        </md-select>
      </md-input-container>
      <md-input-container style="margin:unset">
        <label for="mouth">Mouth</label>
        <md-select name="mouth" id="mouth" v-model="rarity.mouth">
          <md-option value='0.00000861103935244984'>8 Ball</md-option>
          <md-option value='0.00000680272108843538'>Bubble Pop</md-option>
          <md-option value='0.00000839842109683379'>Cigarette</md-option>
          <md-option value='0.0000158202816010125'>Diamond Grill</md-option>
          <md-option value='0.00000872143729286586'>Drool</md-option>
          <md-option value='0.0000090702947845805'>Fangz</md-option>
          <md-option value='0.0000069415521310565'>Forced Smile</md-option>
          <md-option value='0.000013883104262113'>Gold Grill</md-option>
          <md-option value='0.000007475517679599310'>Pizza</md-option>
          <md-option value='0.00000829600132736021'>Quiet</md-option>
          <md-option value='0.0000101533150573662'>Rainbow Drool</md-option>
          <md-option value='0.0000283446712018141'>Rainbow Grill</md-option>
          <md-option value='0.0000125976316452507'>Rainbow Vomit</md-option>
          <md-option value='0.00000895094880057286'>Shout</md-option>
          <md-option value='0.000021944261575598'>Shroomz</md-option>
          <md-option value='0.00000985901607019619'>Smiles</md-option>
          <md-option value='0.00000883470271225373'>Snarl</md-option>
          <md-option value='0.00000907029478458050'>Trippy Tab</md-option>
          <md-option value='0.000010972130787799'>Yawn</md-option>
          <md-option value='0.00000747551767959931'>Yuck</md-option>
          <md-option value='0.0000100040016006403'>Yummy</md-option>
        </md-select>
      </md-input-container>


<details style="grid-column: 1 / 3; text-align:center">
  <summary style="font-weight:bold">How is the Rarity calculated?</summary>
  <div>For each trait:<br>
    <code>[Rarity Score for a Trait Value] = 1 / ([Number of Items with that Trait Value] / [Total Number of Items in the Collection])</code>
    <br>
    The numbers are ultimately summed up and you receive the overall rarity score of your NFT. The higher the score is, the rarer your NFT.  
  </div>
    
</details>





    </div>

    <div v-else-if="link.site == 'CoreApesCalculatorv2'" style="display:grid;gap: 10px; padding:10px;grid-template-columns: repeat(2, minmax(0, 1fr));">
      <h2 style="grid-column: 1 / 3;margin:unset;text-align:center">Core Apes Rarity Tool</h2>
      <md-input-container md-inline style="grid-column: 1 / 3;width:50%; margin-left:25%; margin-right:25%">
        <label>Core Ape Number</label>
        <md-input type="number" v-model="nftNumber" maxlength=4 v-on:input="nftFilter()"></md-input>
        <md-icon>search</md-icon>
      </md-input-container>
      <div v-if="nftNumber" style="grid-column: 1 / 3;border-radius:10px; overflow:hidden">
      <img v-if="link.metadata[this.nftNumber] != undefined" :src="link.metadata[this.nftNumber].image_url.replace('ipfs://','https://ipfs.io/')" style="grid-column: 1 / 3;margin: 0 auto; ">
      <div v-if="link.metadata[nftNumber]" style="display:flex; background:#000000; color:#ffffff; justify-content: space-between; padding:5px 10px;text-align:center; font-weight:bolder; font-size:large; line-height:initial;">
        <div>{{link.metadata[nftNumber].name}}</div>
        <div>RARITY: {{link.metadata[nftNumber].rarity.toFixed(4)}}</div>
      </div>
      
    </div>
      <!-- <div v-if="nftNumber && link.metadata[nftNumber] && nftNumber <= 100" style="grid-column: 1 / 3; text-align:center; font-weight:bolder; font-size:x-large; line-height:initial;padding:5px;">OG CORE APE</div> -->
   
      <md-input-container style="margin:unset" v-if="nftNumber">
        <label for="og">OG Core Ape</label>
        <!-- <md-select name="background" id="background" v-model="link.metadata[nftNumber].attributes[6]">
          <md-option value='true'>True</md-option>
          <md-option value='false'>False</md-option>
        </md-select> -->
        <md-input disabled style="color:black; text-transform:capitalize " name="og" id="og" v-model="link.metadata[nftNumber].attributes[6]"></md-input>

      </md-input-container>

       <md-input-container style="margin:unset" v-if="nftNumber">
        <label for="background">Background</label>
        <md-input disabled style="color:black" name="headwear" id="headwear" v-model="link.metadata[nftNumber].attributes[0].value"></md-input>
      </md-input-container>

      <md-input-container style="margin:unset" v-if="nftNumber">
        <label for="skin">Skin</label>
        <md-input disabled style="color:black" name="skin" id="skin" v-model="link.metadata[nftNumber].attributes[1].value"></md-input>
      </md-input-container>


      <md-input-container style="margin:unset" v-if="nftNumber">
        <label for="outfit">Outfit</label>
        <md-input disabled style="color:black" name="outfit" id="outfit" v-model="link.metadata[nftNumber].attributes[2].value"></md-input>
      </md-input-container>

      <md-input-container style="margin:unset" v-if="nftNumber">
        <label for="eyes">Eyes</label>
        <md-input disabled style="color:black" name="eyes" id="eyes" v-model="link.metadata[nftNumber].attributes[3].value"></md-input>
      </md-input-container>
      
      <md-input-container style="margin:unset" v-if="nftNumber">
        <label for="headwear">Headwear</label>
        <md-input disabled style="color:black" name="headwear" id="headwear" v-model="link.metadata[nftNumber].attributes[4].value"></md-input>
      </md-input-container>

      <md-input-container style="margin:unset" v-if="nftNumber">
        <label for="mouth">Mouth</label>
        <md-input disabled style="color:black" name="mouth" id="mouth" v-model="link.metadata[nftNumber].attributes[5].value"></md-input>
      </md-input-container>


<details style="grid-column: 1 / 3; text-align:center">
  <summary style="font-weight:bold">How is the Rarity calculated?</summary>
  <div>For each trait:<br>
    <code>[Rarity Score for a Trait Value] = 1 / ([Number of Items with that Trait Value] / [Total Number of Items in the Collection])</code>
    <br>
    The numbers are ultimately summed up and you receive the overall rarity score of your NFT. The higher the score is, the rarer your NFT.  
  </div>
    
</details>

<div>{{ Object.keys(this.link.metadata).length }}/1493 ({{ ((Object.keys(this.link.metadata).length/1493)*100).toFixed(2) }}%)</div>



    </div>


    <div v-else-if="link.site == 'Section'" :id="'section_'+link.id" class="link" style="background:unset" disabled :class="{['style'+user.iconStyle]:true, 'compact': linkFormatting.compactLinks, 'floating': linkFormatting.floating}" >
      <!-- <div v-if="!linkFormatting.floating" class="icon">
        <siteicon v-if="!user.showIcons" :account="parseInt(user.account)" :enableUpgrades="user.enableUpgrades" :link="link" :compact="linkFormatting.compactLinks" :iconStyle="user.iconStyle" />
      </div> -->
      <div class="text" v-bind:style="{color: getTextColour}">
        <div class="title" v-if="link.description" v-html="link.description" v-bind:style="[link.styling, {color:link.color}]"></div>
        <div class="title" v-else v-html="link.user" v-bind:style="[link.styling, {color:link.color}]"></div>
        <div class="description" v-if="link.customdescription" v-html="link.customdescription"></div>
        </div>
        <!-- <md-button v-if="link.qrcode" class="md-icon-button" style="margin:unset" v-bind:style="{color: getTextColour}" @click="openQRDialog(link.site, link.base, link.user, link.suffix, link.site);">
        <md-icon>qr_code_2</md-icon>
      </md-button> -->
    </div>

    <!-- INLINE GROUP -->
    <div v-else-if="link.site == 'Link Group' && link.inline" class="link inLineGroup" :disabled="link.site == 'Link Group'" :class="{'qrcode': link.qrcode, 'group':link.site == 'Link Group', 'groupNoIcon': (link.site == 'Link Group' && link.groupIcon != true), 'imageHeader': (link.linkGroupImageHeader != undefined)}" v-bind:style="{background:getBackground}" @click="if(link.site != 'Link Group'){openLink()}">
      <div v-if="link.linkGroupImageHeader" >
        <img class="linkGroupImageHeader" :src="link.linkGroupImageHeader" />
        <div v-if="link.description" class="text" v-bind:style="{color: getTextColour}" style="padding: 8px; padding-top: 8px; padding-bottom: 8px; align-items: center; display: grid !important; width: 100%;">
          <div class="title" v-bind:style="{color: getTextColour}" v-if="link.description && link.showChildCount" v-html="link.description + 'x'" style="font-weight:bold; font-size:16px;"></div>
          <div class="title" v-bind:style="{color: getTextColour}" v-else-if="link.description" v-html="link.description" style="font-weight:bold; font-size:16px;"></div>
          <!-- <div class="title" v-bind:style="{color: getTextColour}" v-else>{{link.site}}</div> -->
          <div class="description" v-bind:style="{color: getTextColour}" v-if="link.customdescription" v-html="link.customdescription"></div>
        </div>
      </div>
        

      <div v-if="((link.site == 'Link Group' && link.groupIcon ) || link.site != 'Link Group')" class="icon">
        <siteicon v-if="!user.showIcons" :account="parseInt(user.account)" :enableUpgrades="user.enableUpgrades" :link="link" :compact="linkFormatting.compactLinks" :iconStyle="user.iconStyle" />
      </div>
      
      <div class="text" v-if="link.linkGroupImageHeader == undefined && (link.description || link.customdescription)" v-bind:style="{color: getTextColour}">
        <div class="title" v-if="link.description" v-html="link.description"></div>
        <!-- <div class="title" v-else>{{link.site}}</div> -->
        <div class="description" v-if="link.customdescription" v-html="link.customdescription"></div>
        </div>
    </div>
    <!-- Link Grid -->
    <div v-else-if="link.site == 'Link Grid' && link.inline" class="link inLineGroup" :disabled="link.site == 'Link Group'" :class="{'qrcode': link.qrcode, 'group':link.site == 'Link Group' || link.site == 'Link Grid', 'groupNoIcon': (link.site == 'Link Group' && link.groupIcon != true)}" v-bind:style="{background:getBackground}" @click="if(link.site != 'Link Group'){openLink()}">
      <!-- <div v-if="link.linkGroupImageHeader" >
        <img class="linkGroupImageHeader" :src="link.linkGroupImageHeader" />
        <div v-if="link.description" class="text" v-bind:style="{color: getTextColour}" style="padding: 8px; padding-top: 8px; padding-bottom: 8px; align-items: center; display: grid !important; width: 100%;">
          <div class="title" v-bind:style="{color: getTextColour}" v-if="link.description && link.showChildCount" v-html="link.description + 'x'" style="font-weight:bold; font-size:16px;"></div>
          <div class="title" v-bind:style="{color: getTextColour}" v-else-if="link.description" v-html="link.description" style="font-weight:bold; font-size:16px;"></div>
          <div class="description" v-bind:style="{color: getTextColour}" v-if="link.customdescription" v-html="link.customdescription"></div>
        </div>
      </div> -->
        

      <!-- <div v-if="((link.site == 'Link Group' && link.groupIcon ) || link.site != 'Link Group')" class="icon">
        <siteicon v-if="!user.showIcons" :account="parseInt(user.account)" :enableUpgrades="user.enableUpgrades" :link="link" :compact="linkFormatting.compactLinks" :iconStyle="user.iconStyle" />
      </div> -->
      
      <!-- <div class="text" v-if="link.linkGroupImageHeader == undefined && (link.description || link.customdescription)" v-bind:style="{color: getTextColour}">
        <div class="title" v-if="link.description" v-html="link.description"></div>
        <div class="description" v-if="link.customdescription" v-html="link.customdescription"></div>
        </div> -->
    </div>
    
    <!-- <cinemapper v-else-if="link.site === 'CineMapper App'" :user="this.user" :link="this.link.id"></cinemapper> -->
    <scratchandwin v-else-if="link.site === 'ScratchAndWin'" :user="this.user" :link="this.link"></scratchandwin>
    <gos v-else-if="link.site === 'GoS'"></gos>

    

    <div v-else-if="link.site === 'Album Player'" v-bind:style="{background: link.background, color:getTextColour}">
      <div class="albumListing" style="padding:10px;display:flex; flex-direction:column; gap:5px;width:100%">
        <div v-for="(track, index) in link.album" v-bind:key="index" class="track" style="padding:5px; display:flex; border:0px solid white">
          <div style="margin-right:5px;font-weight:bold; font-size:medium;">{{ (index + 1).toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping: false }) }}</div>
          <div style="width:100%; user-select: none;" @click="sendDataToParent('albumPlayer', {...track, index, linkId: link.id})">
            <div class="title" style="font-weight:bold; font-size:medium">{{ track.title }}</div>
            <div class="artist" style="display:inline-flex">
              <md-icon v-if="track.explicit" style="font-size: 16px;justify-content: start;margin-right:3px; height: unset; min-height: unset;width: unset; min-width: unset;">explicit</md-icon>
              {{ track.artist }}</div>
          </div>
          <div style="display: flex;  align-items: center;">
            <!-- <span > -->
              <div v-if="track.duration" style="width:40px;  text-align:right">{{ track.duration }}</div>
            <!-- </span> -->
          </div>
        </div>
      </div>
      <!-- <div style="padding:20px; background:silver">this will be the music player</div> -->
    </div>

    <div v-else-if="link.site == 'Pipedream Form'" style="padding:16px">
      <form @submit.prevent="submitPipedreamForm">
        <div v-for="(input, index) in link.formInputs" :key="index">
          <md-input-container class="compactContainer">
            <label>{{ input.label }}</label>
            <md-input 
              v-model="formData[input.name]"
              :type="input.type || 'text'"
              :required="input.required"
              :placeholder="input.placeholder">
            </md-input>
          </md-input-container>
        </div>
        
        <md-button 
          type="submit"
          class="md-primary md-raised rounded5" 
          style="margin:unset; width:100%;">
          {{ link.submitText || 'Submit' }}
        </md-button>
      </form>

      <md-snackbar 
        md-position="bottom center" 
        :md-duration="4000" 
        ref="formSnackbar">
        <span>{{ snackbarMessage }}</span>
        <md-button class="md-accent" @click="$refs.formSnackbar.close()">Close</md-button>
      </md-snackbar>
    </div>

    <div v-else-if="link.site == 'Email Capture'" style="padding:16px">
      <div v-html="link.emailCaptureDescription"></div>

          <form novalidate @submit.stop.prevent="submit" autocomplete="off">
            <md-input-container class="compactContainer">
              <label>Name</label>
              <md-input required v-model="emailCollection.name"></md-input>
            </md-input-container>
            <md-input-container class="compactContainer">
              <label>Email</label>
              <md-input required type="email" v-model="emailCollection.email"></md-input>
            </md-input-container>
          </form>
          <md-button  class="md-primary md-raised rounded5" style="margin:unset; width:100%;" @click="collectEmail()">Ok</md-button>

          <div style="margin-top:20px;font-size:x-small; font-weight:bold; line-height:15px">{{ link.disclaimer ? link.disclaimer : 'By entering your name and email to access this link/content, you are consenting to your details being used for marketing purposes by the owner of this Slink page. Your information is not stored by Slink.'  }}</div>
        </div>
         


    <!-- <details class="link" v-else-if="link.site == 'Link Group' && !link.inline" v-bind:style="{background:getBackground, color: getTextColour}" style="padding: 8px 0px 8px 8px;">
      <summary :id="link.id" style="display:grid; grid-template-columns: 56px auto 40px; min-height: 56px;gap: 12px;">
        <div class="icon">
          <siteicon v-if="!user.showIcons" :account="parseInt(user.account)" :enableUpgrades="user.enableUpgrades" :link="link" :compact="linkFormatting.compactLinks" :iconStyle="user.iconStyle" />
        </div>
        <div class="text" v-bind:style="{color: getTextColour}">
            <div class="title" v-if="link.description" v-html="link.description">{{link.site}}</div>
            <div class="title" v-else>{{link.site}}</div>
            <div class="description" v-if="link.customdescription">{{link.customdescription}}</div>
        </div>
      </summary>
     
    </details> -->

    <div v-else-if="link.site=='IFrame'" class="link" style="gap: 5px;     display: flex; width: 100%; flex-flow: column;">
      <iframe :src="link.user"></iframe>
    </div>



    <div v-else-if="link.site=='Tips'" class="link" style="gap: 5px;
    display: flex;
    width: 100%;
    flex-flow: column;"><div class="text" style="padding: 10px 10px 0 10px;">
    <div class="title" v-bind:style="{color: getTextColour}" v-if="link.description" v-html="link.description"></div>
        <div class="title" v-bind:style="{color: getTextColour}" v-else>Send me a tip!</div>
        <div class="description" v-bind:style="{color: getTextColour}" v-if="link.customdescription" v-html="link.customdescription"></div>
    
    
    </div>
    <div style="gap: 10px;
    display: flex;
    padding: 10px;">
    <md-button class="md-raised tipButton" @click="getTipsCheckout('tip10gbp')">£10</md-button>
    <md-button class="md-raised tipButton" @click="getTipsCheckout('tip20gbp')">£20</md-button>
    <md-button class="md-raised tipButton" @click="getTipsCheckout('tip30gbp')">£30</md-button>
    <md-button class="md-raised tipButton" @click="getTipsCheckout('tip40gbp')">£40</md-button>
    <md-button class="md-raised tipButton" @click="getTipsCheckout('tip50gbp')">£50</md-button>
      <!-- <div class="tipButton">£10</div> -->
      <!-- <div class="tipButton">£20</div> -->
      <!-- <div class="tipButton">£30</div> -->
      <!-- <div class="tipButton">£40</div> -->
      <!-- <div class="tipButton">£50</div> -->
      </div>
      </div>

   
      <div v-else-if="link.site == 'WNB Ticket'" style="display:flex; justify-content:center; align-items:center; height: auto;padding: 10px 30px;flex-flow:column;gap:10px;"  :style="{background: getBackground}">
      
      <!-- <div style="background-repeat: no-repeat;
    background-image: url(https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o/userContent%2F-NIXOF6E2iMy7Xz_iyrJ%2FMPMTicket.png?alt=media&token=8a5188a4-df15-4dc3-bd13-42d8b8ccf5fa);
    font-weight: bold;
    font-size: 2em;
    line-height: 1.5em;
    aspect-ratio: 4/3;
    width: 100%;
    background-size: contain;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;">{{getRand}}</div> -->
    <div v-if="this.user.ticketNumber && getPrize && !prize.claimed && (LS.game.uid === prize.player || prize.player == undefined)" style="width:100%; display:flex; flex-flow:column;gap:10px; justify-content:center; align-items:center;max-width:300px">
      <div v-if="LS.game.collected == true" style="background: white;border-radius: 10px;overflow: hidden;">
      <scratch-card :key="renderCount"
                  :cardWidth="link.scratchcardWidth"
                  :cardHeight="link.scratchcardHeight"
                  :finishPercent="75"
                  :imageUrl="link.scratchcardImage"
                  :forceReveal="forceReveal"
                   style="border-radius:10px; overflow:hidden; " v-bind:style="link.scratchcardStyle"
                   @complete="prizeClaimed()">
        <div class="card-content" v-html="prize.prize" v-bind:class="{shake: forceReveal}" style="text-transform: uppercase"></div>
      </scratch-card>
      <div style="color:#E20461; text-align:center; font-weight:bold;padding:3px;">{{prize.id}}
        <img :src="'https://api.qrserver.com/v1/create-qr-code/?data='+ticketJSON" alt="Avatar" style="z-index:10;width:40px;position:fixed; bottom:10px; right:10px; padding:2px; background:#ffffff; border-radius:10px" v-bind:class="{ticketQRLarge: ticketQRToggle}" @click="toggleQR">
      </div>
    </div>
    <!-- <button @click="forceReveal = true">Force Reveal!</button> -->
    <!-- <button @click="renderCount++">Force Reset</button> -->
      
        <!-- <div style="font-size: initial;font-weight:initial;text-align:center; color:#ffffff">What can I win?</div> -->
        <!-- <details style="text-align:center;color:#ffffff;font-size: initial;font-weight:initial;">
  <summary style="font-weight:bold; text-transform:uppercase">What can I win?</summary>
  <div>Epcot is a theme park at Walt Disney World Resort featuring exciting attractions, international pavilions, award-winning fireworks and seasonal special events.</div>
</details> -->


  <!-- Begin Mailchimp Signup Form -->
<div v-if="LS.game.collected != true" style="width:100%; border:5px solid #ffffff; border-radius:10px; background:#ffffff; padding:10px">
    <div style="width:100%; text-align:center; font-weight:bold; text-transform:uppercase">Sign up to reveal your scratchcard!</div>
    <!-- <form action="https://smackshamburgers.us1.list-manage.com/subscribe/post?u=0e9ce23b1e2c0996e856de323&amp;id=8b4184a228&amp;f_id=00f6e3e5f0" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_self"> -->
		<md-input-container md-inline style="min-height:unset; margin:unset;" v-bind:class="{'md-input-invalid': isEmail(scratchCardData.email)}">
			<label style="font-weight:bold">Email Address</label>
			<md-input type="email" v-model="scratchCardData.email" value="" name="EMAIL" id="mce-EMAIL" required style="font-weight:bold"></md-input>
      <span class="md-error" style="padding:unset">Enter a valid email address!</span>
    </md-input-container>
    <md-input-container md-inline style="min-height:unset; margin:unset;">
			<label style="font-weight:bold">First Name</label>
			<md-input type="text" v-model="scratchCardData.name" value="" name="FNAME" id="mce-FNAME" required style="font-weight:bold"></md-input>
    </md-input-container>
    <md-input-container md-inline style="min-height:unset; margin:unset;" v-bind:class="{'md-input-invalid': isMobileNumber(scratchCardData.phone)}">
			<label style="font-weight:bold">Mobile</label>
			<md-input type="text" v-model="scratchCardData.phone" name="PHONE" value="" id="mce-PHONE" required style="font-weight:bold"></md-input>
      <span class="md-error" style="padding:unset">Enter a valid uK mobile number without spaces!</span>
    </md-input-container>
    <md-button :disabled="isEmail(scratchCardData.email) != false || isMobileNumber(scratchCardData.phone) != false || (scratchCardData.name == undefined)" type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" class="md-raised md-dense md-accent" @click="scratchCardDataCollection(scratchCardData)" style="font-weight:bold; margin:30px 0 0 0;width:100%; border-radius:7px">Subscribe</md-button>

		<div id="mc_embed_signup_scroll">

	<div id="mce-responses" class="clear foot">
		<div class="response" id="mce-error-response" style="display:none"></div>
		<div class="response" id="mce-success-response" style="display:none"></div>
	</div>    <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
    <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_0e9ce23b1e2c0996e856de323_8b4184a228" tabindex="-1" value=""></div>
        <div class="optionalParent">
            <div class="clear foot">
                <!-- <input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" class="button"> -->
                <!-- <p class="brandingLogo"><a href="http://eepurl.com/im4O6s" title="Mailchimp - email marketing made easy and fun"><img src="https://eep.io/mc-cdn-images/template_images/branding_logo_text_dark_dtp.svg"></a></p> -->
            </div>
        </div>
    </div>
<!-- </form> -->
</div>

<!--End mc_embed_signup-->


<details v-if="link.tandcs" style="text-align:center;color:#ffffff;font-size: initial;font-weight:initial;">
  <summary style="font-weight:bold; text-transform:uppercase">Terms & Conditions</summary>
  <div style="text-transform:uppercase; font-size:x-small; line-height:normal;text-align:justify" v-html="link.tandcs"></div>
</details>
</div>

<div v-else-if="prize.claimed" style="font-size:xx-large;text-align:center; line-height:35px;color:white">This scratchcard and prize has already been claimed.<br><span style="font-weight:bold; font-size:small">{{prize.id}}</span></div>
<div v-else-if=" (LS.game.uid != prize.player || prize.player != undefined)" style="font-size:xx-large;text-align:center; line-height:35px;color:white">This scratchcard has already been used.<br>
  <span style="font-weight:bold; font-size:small">{{prize.id}}</span></div>
<div v-else style="color:white">This ticket is not valid</div>
      
    </div>
    <!-- link grid links -->
    <div v-else-if="link.group && link.linkGrid" class="linkgrid_Container" :disabled="link.site == 'Link Group'"style="display:flex;  padding:10px; min-width:100%; flex-flow:column; gap:10px;align-items:center;" @click="if(link.site != 'Link Group'){openLink()}">
        <!-- <siteicon v-if="!user.showIcons" :account="parseInt(user.account)" :enableUpgrades="user.enableUpgrades" :link="link" :compact="linkFormatting.compactLinks" :iconStyle="user.iconStyle" /> -->
        <!-- <md-avatar class="siteicon"  v-bind:style="{ color: link.color, background: link.background }" > -->
            <i v-if="!link.favicon && link.site != 'Image'" class="fa fa-fw fa-3x" v-bind:class="['fa-'+ link.fa]" v-bind:style="{ color: link.color,  }" aria-hidden="true" ></i>
            <div class="title" v-bind:style="{color: getTextColour}" v-html="link.description || link.site"></div>
        <!-- <div class="title" v-bind:style="{color: getTextColour}" v-else>{{link.site}}</div> -->
        <!-- </md-avatar> -->

  
    </div>
    <!-- Standard Link -->

    <div v-else class="link" :disabled="link.site == 'Link Group'" :class="{'qrcode': link.qrcode, 'group':link.site == 'Link Group', 'groupNoIcon': (link.site == 'Link Group' && link.groupIcon != true)}" @click="if(link.site != 'Link Group'){openLink()}">
      <div v-if="((link.site == 'Link Group' && link.groupIcon ) || link.site != 'Link Group') && linkFormatting.showIcons != true" class="icon" v-bind:style="{background: getGroupMemberBackground}">
        <siteicon v-if="!user.showIcons" :account="parseInt(user.account)" :enableUpgrades="user.enableUpgrades" :link="link" :compact="linkFormatting.compactLinks" :iconStyle="user.iconStyle" />
      </div>
      <div class="text" v-bind:style="{color: getTextColour}">
        <div class="title" v-bind:style="{color: getTextColour}" v-if="link.description" v-html="link.description"></div>
        <div class="title" v-bind:style="{color: getTextColour}" v-else>{{link.site}}</div>
        <div class="description" v-bind:style="{color: getTextColour}" v-if="link.customdescription" v-html="link.customdescription"></div>
        </div>
        <md-button v-if="link.qrcode" class="md-icon-button" style="margin:unset; height:100%" v-bind:style="{color: getTextColour}" 
            @click="link.site === 'Image' ? openQRDialog(null, null, link.imageLink, null, link.site) : openQRDialog(link.site, link.base, link.user, link.suffix, link.site);">
        <md-icon style="margin-left:unset">qr_code_2</md-icon>
      </md-button>
    </div>


    <md-dialog ref="popoutContent" class="popoutContent">
  <md-dialog-title style="text-transform:uppercase; font-weight:bold; font-size:18px;margin-bottom:unset;padding:10px 10px 0 10px; text-align:center" v-html="content.title"></md-dialog-title>

  <md-dialog-content style="aspect-ratio: 9 / 16;
    border-radius: 15px;
    margin: 10px;
    padding: 0;"  v-bind:style="content.style" v-html="content.source">
  </md-dialog-content>

  <!-- <md-dialog-actions>
    <md-button class="md-primary" @click="closeDialog('changeVideo')">Close</md-button>
  </md-dialog-actions> -->
</md-dialog>



    <md-dialog-alert :md-title="tiktokSafetyWarning.title" :md-content-html="tiktokSafetyWarning.contentHtml" ref="tiktokDialog" class="tiktokDialog" />
     
    <md-dialog-alert :md-title="qrcode.title" :md-content-html="qrcode.contentHtml" ref="qrcodeDialog" class="qrDialog" />

    <md-dialog v-if="link.passwordEmail || link.password" :md-click-outside-to-close=false class="passwordPrompt" ref="passwordPrompt">
      <md-dialog-title v-bind:style="{background: link.background, color: link.color}">
        <!-- {{link.site}} -->
        Unlock Content
      <span style="flex: 1"></span>

        <md-icon v-bind:style="{color: link.color}">lock</md-icon>
      </md-dialog-title>

      <md-dialog-content>
        <div v-if="link.passwordEmail">
          <div>This link/content is protected, please provide your name and email to unlock access.</div>

          <form novalidate @submit.stop.prevent="submit" autocomplete="off">
            <md-input-container class="compactContainer">
              <label>Name</label>
              <md-input required v-model="emailCollection.name"></md-input>
            </md-input-container>
            <md-input-container class="compactContainer">
              <label>Email</label>
              <md-input required type="email" v-model="emailCollection.email"></md-input>
            </md-input-container>
          </form>
          <div style="font-size:x-small; font-weight:bold; line-height:15px">By entering your name and email to access this link/content, you are consenting to your details being used for marketing purposes by the owner of this Slink page. Your information is not stored by Slink.</div>
        </div>
        <div v-else>
          <div>This link/content is protected, please enter password to unlock access.</div>
          <form novalidate @submit.stop.prevent="submit">
            <md-input-container class="compactContainer" md-has-password>
              <label>Passsword</label>
              <md-input v-model="linkPassword" type="password"  autocomplete="off" v-on:input="checkPassword()"></md-input>
            </md-input-container>
            
          </form>
        </div>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary" @click="closeDialog('passwordPrompt')">Cancel</md-button>
        <md-button  v-if="link.passwordEmail" class="md-primary" @click="collectEmail()">Ok</md-button>
      </md-dialog-actions>
    </md-dialog>

      <md-snackbar ref="linkNotifications" :md-duration="3600">
        <span>{{ notification }}</span>
        <md-button class="" @click="$refs.linkNotifications.close()">OK</md-button>
      </md-snackbar>

<!-- <md-dialog-prompt
  :md-title="prompt.title"
  :md-ok-text="prompt.ok"
  :md-cancel-text="prompt.cancel"
  :md-input-maxlength="prompt.maxlength"
  :md-input-placeholder="prompt.placeholder"
  @open="onOpen"
  @close="onClose"
  v-model="prompt.value"
  ref="dialog6">
</md-dialog-prompt> -->
   <!-- <div style="widdth:100%; display:flex; justify-content:center" v-if="user.beta">{{source}}</div> -->
  </div>  
     
</template>

// Our functional scripts will go here
<script>
import {fb} from './firebaseconfig'
import { analytics } from "./firebaseconfig";

let db = fb.database();

import siteicon from "./siteicon_component";
import linkinfo from "./linkinfo_component";
// import cinemapper from "./cinemapper";
import scratchandwin from "./scratchandwin"
import gos from "./gos"
import WhisperBox from "./whisper_box";

import FlipCountdown from 'vue2-flip-countdown'
import ScratchCard from 'vue-scratchcard';

export default {
  components:{
    siteicon,
    linkinfo,
    FlipCountdown,
    ScratchCard,
    // cinemapper,
    scratchandwin,
    gos,
    WhisperBox
  },
  props:{
    link: Object,
    user: Object,
    linkFormatting: Object,
  },
  metaInfo () {
      return {
        link: [
            // { rel: 'stylesheet', href: this.customFont },
        ],
        meta: [
        ],
        title: this.getPageTitle,
        script: [
          { src: this.embedScript},
          // { src: this.tiktokScript },
          // { src: this.igScript },
          // { src: this.gumroadScript },
          // { src: this.twitterScript },
          // { src: this.openseaScript },
          // { src: 'https://www.tiktok.com/embed.js'}, //TikTok Embed
          // { src: 'https://www.instagram.com/embed.js'}, //IG Embed
          // { src: 'https://poweredby.jads.co/js/jads.js'},
        ],
        noscript: [
          // { innerHTML: this.fbPixelNoScript }
        ]
      }
    },
  data() {
    return {
    //   status: false,
    content:{title:null, source:null},
    LS: null,
    prize:null,
    ticketQRToggle:false,
    renderCount: 0,
      // cardWidth: 300,
      // cardHeight: 200,
      finishPercent: 70,
      forceReveal: false,
    arHeight:null,
    source: document.referrer,
      emailCollection:{},
      passwordPrompt: {},
      activeMedia: false,
      linkPassword: null,
      embedScript: null,
      notification: null,
      sliderDuration:5,
      tiktokSafetyWarning: {
        title: 'TikTok Safety Warning',
        contentHtml: '<p style="padding-bottom:10px">TikTok restricts access to ' + this.link.site +' from within its platform.</p><p>Not to worry, the link has been copied to your clipboard so you can paste it <strong>directly</strong> in to your browser of choice.</p>'
      },
      qrcode: {
        title: 'Slink QR Code',
        contentHtml: 'qrcode'
      },
      treasureHuntAnswer:null,
      treasureHuntQuestionsLeft:null,
      scratchCardData:{},
      nftNumber: null,
      rarity: {'outfit':0, 'eyes': 0, 'mouth': 0, 'headwear': 0, 'skin': 0, 'background':null},
      // rarity:{},
      formData: {},
      snackbarMessage: '',
    };
  },
  watch:{
//     user(value){
//       // console.log('the active track is', value.activeTrack)
// // 
//       // if(value.activeTrack){
//       //   console.log('the active track is', value.activeTrack)
//       //   // this.sendDataToParent('albumPlayer', {...this.link.album[value.activeTrack], index: value.activeTrack})
//       // }
//     }
  },
  computed:{
    getVotes(){
      let votes = ((this.link.teamA.votes/(this.link.teamA.votes + this.link.teamB.votes))*100)
      votes = isNaN(votes) ? 50 : votes
      return votes
    },
    // getImages(){
    //   // console.log(typeof this.link.images)
    //   for(var i in this.link.images){
    //     this.link.images[i].id = i
    //   }

    //   if(this.link.site == 'Carousel' && this.link.autoslide){
    //     let carouselData = {}
    //     carouselData.numberOfImages = Object.keys(this.link.images).length * 2
    //     carouselData.imgWidth = this.link.imgWidth ? this.link.imgWidth : 300
    //     carouselData.totalWidth = (carouselData.numberOfImages * carouselData.imgWidth) + ((carouselData.numberOfImages - 1) * 10)
    //     this.sliderDuration = carouselData.totalWidth /60
    //   }
    //   // console.log(this.link.images)
    //   return _.orderBy(this.link.images, "order");``
    //   // return this.link.images
    // },
    getImages() {
    // First, ensure each image has an id set
    for (var i in this.link.images) {
      this.link.images[i].id = i;
    }

    // Sort images by 'order' and filter out images where 'visible' is false
    let images = _.chain(this.link.images)
                  .orderBy('order')
                  .filter(image => image.visible !== false)
                  .value();

    // Check if the carousel should autoslide
    if (this.link.site === 'Carousel' && this.link.autoslide) {
      // Duplicate the images array for the autoslide effect
      images = images.concat(_.cloneDeep(images)); // Use _.cloneDeep to avoid mutating the original objects

      // Calculate carousel data for autoslide
      let carouselData = {
        numberOfImages: images.length, // Updated to use the duplicated array's length
        imgWidth: this.link.imgWidth ? this.link.imgWidth : 300,
      };
      carouselData.totalWidth = (carouselData.numberOfImages * carouselData.imgWidth) + ((carouselData.numberOfImages - 1) * 10);
      this.sliderDuration = carouselData.totalWidth / 60;
    }

    return images;
},

  //   getImages() {
  //   // First, ensure each image has an id set
  //   for (var i in this.link.images) {
  //     this.link.images[i].id = i;
  //   }

  //   let images = _.orderBy(this.link.images, "order");

  //   // Check if the carousel should autoslide
  //   if (this.link.site === 'Carousel' && this.link.autoslide) {
  //     // Duplicate the images array for the autoslide effect
  //     images = images.concat(_.cloneDeep(images)); // Use _.cloneDeep to avoid mutating the original objects

  //     // Calculate carousel data for autoslide
  //     let carouselData = {
  //       numberOfImages: images.length, // Updated to use the duplicated array's length
  //       imgWidth: this.link.imgWidth ? this.link.imgWidth : 300,
  //     };
  //     carouselData.totalWidth = (carouselData.numberOfImages * carouselData.imgWidth) + ((carouselData.numberOfImages - 1) * 10);
  //     this.sliderDuration = carouselData.totalWidth / 60;
  //   }

  //   return images;
  // },
    ticketJSON(){
      return JSON.stringify({'game': this.$route.params.uid, 'id':this.prize.id})
    },
    ticketClaimed(){
      console.log('prizeClaimed')
      console.log(this.LS)

        localStorage.setItem('game_'+self.$route.params.uid,JSON.stringify(game))
        var updateClicksRef =  db.ref('tickets/'+ self.$route.params.uid +'/'+ prize['.key'] +'/player');
        console.log(updateClicksRef)
        updateClicksRef.transaction(function (current_value) {
          return game.uid;
        });
        self.LS.game = {}
        self.LS.game = game
      

      return JSON.stringify({'game': this.$route.params.uid, 'ticket':this.prize.id})

    },
    getPrize(){
      let self = this
      if(this.prize){
        return this.prize
      }
      if(this.$route.params.ticket == 'play'){
        console.log('getting random')
        const ticket = db.ref('tickets/'+ this.user.url).orderByChild('random').equalTo(true).limitToFirst(1).once('value').then(function(snapshot) {
        let t = snapshot.val()
        // console.log(t)
        let prize = null
        for(var i in snapshot.val()){
          prize = t[i]
          // prize = t[i].prize
        }
        self.prize = prize
      })
      }
      else{
        const ticket = db.ref('tickets/'+ this.user.url).orderByChild('id').equalTo(this.$route.params.ticket).on('value', (snapshot) => {
        let t = snapshot.val()
        console.log(t)
        let prize = null
        for(var i in snapshot.val()){
          prize = t[i]
          prize['.key']  = i
          // prize = t[i].prize
        }
        self.prize = prize
        self.LS = {}
        self.LS.game = JSON.parse(localStorage.getItem('game_'+self.$route.params.uid));
        console.log('LS_tickets', self.LS.game)
        if (self.LS.game == null){
          self.LS.game = {}
          const crypto = require('crypto');
          const uuid = crypto.randomBytes(12).toString('hex')
          self.LS.game.uid = uuid
        }
        localStorage.setItem('game_'+self.$route.params.uid,JSON.stringify(self.LS.game))
        // console.log('already played', self.LS.game)
        // if(self.LS.game.tickets == undefined){
        //   console.log('no tickets')
        // }
        
        // self.LS.game.tickets[prize.id] = true
        // console.log('already played', self.LS.game)

        // console.log(self.LS.game.uid == prize.player)

        // localStorage.setItem('game_'+self.$route.params.uid,JSON.stringify(game))
        console.log('player', prize.player)
        // if(prize.player == undefined){
        //   db.ref('tickets/'+ self.$route.params.uid +'/'+ prize['.key'] +'/player').transaction(function (current_value) {
        //     return self.LS.game.uid;
        //   });

        // }
        
        // self.LS.game = {}
        // seld.LSgame = game
      
      })  
      }
          
      
      


      return this.prize
    },
    getRand(){
      let storedRand = JSON.parse(localStorage.getItem("ticket"));
      console.log('getRand stored ticket', storedRand)
      if(storedRand == null){
        let available = Object.entries(this.link.rand).filter(([key, value]) => value.used == false)
        let r = _.sampleSize(Object.fromEntries(Object.entries(available)), 1)
        var updateRand=  db.ref('users/'+ this.user.key +'/links/'+ this.link.id +'/rand/' + r[0][0] + '/used');
        updateRand.transaction(function (current_value) {
          return true;
        });
        storedRand = r[0][1].ticket
        localStorage.setItem("ticket", JSON.stringify(storedRand));
      }
      return storedRand
    },
    
    getGroupMemberBackground:function(){
      if(this.user.iconStyle ==2 && this.link.group){
        return this.link.background
      }
    },
    kissOrSlap:function(){
      console.log('#', this.link.randOptions.length)
      // await setTimeout(5000);
  // let randBoolean = null


  // let self = this
  //     setTimeout(function () {
  //       console.log('1', 'kissorslap', randBoolean)
  //       let randBoolean = Math.random() < 0.5;
  //     console.log('KISSORSLAP', randBoolean)
  //     self.link.kissorslap = randBoolean ? 'Kiss' : 'Slap'
  //     return randBoolean ? 'Kiss' : 'Slap'
  //   }, 5000);

        
        let randBoolean = Math.floor(Math.random() * (this.link.randOptions.length));
        console.log('##', randBoolean)
      // return randBoolean ? 'Kiss!' : 'Slap!'
      return (this.link.randOptions[randBoolean])


      // let randBoolean = Math.random() < 0.5;
      // console.log('KISSORSLAP', randBoolean)

    },
    // getRandomStyling:function(){ //redundant

    // }, 
    getDisplayDeadline:function(){
      let deadline = this.link.user

      // console.log('getDeadline', deadline)
var d = new Date(deadline+'Z');
console.log(d.toString());

      // let timerDeadline = new Date(month+'/'+day+'/'+year+' ' + hours + ':' + minutes + ':' + seconds+' UTC');

      // let year = parseInt(deadline.substr(0,4))
      // let month = deadline.substr(5,2)
      // let day = deadline.substr(8,2)
      // let hours = deadline.substr(11,2)
      // let minutes = deadline.substr(14,2)
      // let seconds = deadline.substr(17,2)
      // let timerDeadline = new Date(month+'/'+day+'/'+year+' ' + hours + ':' + minutes + ':' + seconds+' UTC');
      return d
    },
    getDeadline: function(){
      let deadline = this.link.user
      console.log('getDeadline', deadline)
var d = new Date(deadline+'Z');
console.log(d.toString());

      // let year = deadline.substr(0,4)
      // let month = deadline.substr(5,2)
      // let day = deadline.substr(8,2)
      // let hours = deadline.substr(11,2)
      // let minutes = deadline.substr(14,2)
      // let seconds = deadline.substr(17,2)
      // let timerDeadline = new Date(month+'/'+day+'/'+year+' ' + hours + ':' + minutes + ':' + seconds+' UTC');
      let t = d.getFullYear() + '-' + (d.getMonth() +1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds()
      // let t = timerDeadline.getFullYear() + '-' + (timerDeadline.getMonth() +1) + '-' + timerDeadline.getDate() + ' ' + timerDeadline.getHours() + ':' + timerDeadline.getMinutes() + ':' + timerDeadline.getSeconds()
      // console.log('android', timerDeadline.toLocaleString())
      console.log('ios', t)
      console.log(Intl.DateTimeFormat().resolvedOptions().timeZone)
      return t
    },
    // getCarouselImageWidth:function(){
    //   if(this.link.imgWidth != undefined){
    //     return this.link.imgWidth + 'px'
    //   }
    //   else{
    //     return '300px'
    //   }
    // }, 
    getCarouselImageWidth: function() { //updated
      return this.link.imgWidth !== undefined ? this.link.imgWidth + 'px' : '300px';
    },
    // getImageHeight:function(){
    //   console.log(event)
    //   this.$nextTick(() => {
    //     if(this.link.aspectRatio){
    //       let dimensions = this.link.aspectRatio.split("/") 
    //       this.arHeight = document.getElementById(this.link.id+'_0').clientWidth / dimensions[0] * dimensions[1]
    //       // this.arHeight = 150 / dimensions[0] * dimensions[1]
    //     }
    //   })
    //   return this.arHeight+'px !important'
    // },
    applyAspectRatio: function() {
      // console.log('applyAspectRatio', 'aspectRatio for', this.link.id, this.link.site, this.link.aspectRatio)
      const { aspectRatio, id, group } = this.link;
      if (aspectRatio) {
        const dimensions = aspectRatio.split("/");
        const elementId = group ? group : id;
        this.$nextTick(() => {
          const element = document.getElementById(elementId) || document.getElementById(`section_${elementId}`);
          if (element) {
            const elementWidth = element.clientWidth;
            this.arHeight = `${elementWidth / dimensions[0] * dimensions[1]}px`;
          }
        });
      }
      return `${this.arHeight} !important`;
    },
    // applyAspectRatio1:function(){
    //   this.$nextTick(() => {
    //     if(this.link.aspectRatio){
          
    //       let getLink = this.link.id
    //       if(this.link.group){
    //         getLink = this.link.group
    //       }
    //       let dimensions = this.link.aspectRatio.split("/") 
    //       try{
    //         this.arHeight = document.getElementById(getLink).clientWidth / dimensions[0] * dimensions[1]
    //       }
    //       catch(e){
    //         this.arHeight = document.getElementById('section_'+getLink).clientWidth / dimensions[0] * dimensions[1]
    //       }
    //     }
    //   })
    //   return this.arHeight+'px !important'
    // },
    // getProtectedMediaHight: function(){
    //   this.$nextTick(() => {
    //     document.getElementById('imgContainer'+this.link.id).style.height= document.getElementById('img'+this.link.id).style.height
    //   });
    // },
    mediaLink: function(){
      // console.log(this.link.site)
      // console.log(this.link.user)
      // console.log('mediaLink starting', this.link.site)
      let res = this.link.user.match(/http([^"])*/g)
      
      if(this.link.site == 'YouTube Player'){
        res[0] = res[0].replace(/(youtube.com\/watch\?v=|youtu.be\/)/i,'youtube.com/embed/')
        res[0] = res[0].replace(/youtube.com\/playlist\?list=/i,'youtube.com/embed/?listType=playlist&list=')
      }
      else if(this.link.site == 'Spotify Player'){
        res[0] = res[0].replace(/open.spotify.com\/artist/i,'open.spotify.com/embed/artist')
        res[0] = res[0].replace(/open.spotify.com\/track/i,'open.spotify.com/embed/track')
        res[0] = res[0].replace(/open.spotify.com\/album/i,'open.spotify.com/embed/album')
        res[0] = res[0].replace(/open.spotify.com\/playlist/i,'open.spotify.com/embed/playlist')
        res[0] = res[0].replace(/open.spotify.com\/show/i,'open.spotify.com/embed-podcast/show')
      }  
      else if(this.link.site == 'Apple Music Player'){
        res[0] = res[0].replace(/\/music.apple.com/i,'/embed.music.apple.com')
      }   
      else if(this.link.site == 'Vimeo Player'){
        res[0] = res[0].replace('https://vimeo.com','https://player.vimeo.com/video')
      }
      else if(this.link.site == 'Twitch Player'){
        if(res[0].includes('videos')){
          //var str = "Hello world, welcome to the universe.";
          //var n = str.includes("world");
          //https://www.twitch.tv/videos/695619630
          //https://player.twitch.tv/?parent=www.myslink.app&parent=myslink.app&video=695619630
          res[0] = res[0].replace(/\/www.twitch.tv\//i,'/player.twitch.tv/')
          res[0] = res[0].replace(/videos\//i,'?parent=www.myslink.app&parent=myslink.app&video=')
        }
        
        else{
          res[0] = res[0].replace(/\/www.twitch.tv\//i,'/player.twitch.tv/?parent=www.myslink.app&parent=myslink.app&channel=')
        }
      }
      else if(this.link.site == 'Text Block'){
        // console.log('mediaLink', 'Text Block')
          res = null
        }
      else if(this.link.site == 'TikTok Player'){
        // console.log('tiktok player', res[0])
        if(res[0].indexOf("data-video-id=") == -1){

          res[0] = 'https://www.tiktok.com/embed/'+ res[0].substr(res[0].search('video')+6, 20)
        }
        else{
          res[0] = 'https://unshorten.me/s/'+res[0]
         }
      }
      else if(this.link.site == 'Instagram Post'){
        res[0] = res[0].replace('?', 'embed/?')
        return res[0]
      }
      else if(this.link.site == 'Embed' || this.link.embed){
        
          let fullLink = this.link.base + this.link.user + this.link.suffix
          console.log('mediaLink', fullLink)
        try{
          let findScriptTag = /<script[\s\S]*?>[\s\S]*?<\/script>/gi
          let scriptTag = findScriptTag.exec(fullLink)
          // console.log('ScriptEmbed #1',scriptTag)
          if(scriptTag != null){
            let findScript = /src="[\s\S]*?>[\s\S]*?/gi
          let script = findScript.exec(scriptTag[0])
          script = script[0].replace('src="','')
          // console.log(script.indexOf('"'))
          script = script.substr(0, script.indexOf('"'))
          // console.log('ScriptEmbed #2',script)
          this.embedScript = script

          }
          
          // console.log('ScriptEmbed #2',this.embedScript)

        }catch(e){
          console.log('embed error', e)
        }
        return fullLink

      }
      // console.log('mediaLink TB', res[0])
      return res == null ? this.link.user : res[0]
    },
    // getMediaHeight: function(){
    //     let height = 'auto'
    //     let self = this
    //     try{
    //       if(this.link.site === 'Instagram Post'){
    //         return 'unset'
    //       }
    //       if(this.link.height != undefined && link.site != "YouTube Player"){
    //         this.$nextTick(() => {
    //         document.getElementById(this.link.id).style.height= this.link.height
    //         height = this.link.height
    //         console.log('#1',height)
    //        });
    //       }
    //       if(this.link.site == 'YouTube Player___' || this.link.site =='Vimeo Player'){
          
    //       this.$nextTick(() => {
    //         document.getElementById(this.link.id).style.height= (document.getElementById(this.link.id).clientWidth /1.77)+'px'
    //         height = (document.getElementById(this.link.id).clientWidth /1.77)+'px'
    //        });
    //       }
    //       else if(this.link.site == 'Gallery'){
    //         return 'auto'
    //       }
    //       else{
    //         let res = this.link.user.match(/\bheight="([^"])*"/g)
    //         height = res[0].substring(8,res[0].length-1)+"px"
    //         height = height.replace('pxpx','px')
    //         console.log('#2', height)
    //       }
    //     }
    //     catch (e){
    //       console.log('getMediaHeight Error', e)
    //     }      
    //     console.log('returned', height)
    //     return height
    //   },
    // allowed: function(requirement){  //redudant
    //   return (this.user.account == requirement || this.user.enableUpgrades) ? true : false;
    // },
    getBackground: function() {
      // console.log('##', this.link.site, this.link.user, this.user.account, this.link.background)
      let bg = this.link.background
      if(this.link.linkGrid){
        return 'unset'
      }
      else if((this.linkFormatting.fullColourButtons || this.link.site== 'Link Group') && this.link.background.indexOf("#") == 0 && (this.user.account == 7 || this.user.enableUpgrades)){
        bg = this.link.background 
      }
      else if((this.linkFormatting.media && this.link.inline) || this.link.site == 'Image' || this.link.site == 'Carousel'){
        bg = this.link.background
      }
      else{
        bg = '#ffffff'
      }
      // console.log('###bg' ,  this.link.site, bg)
      if(this.link.site == 'Link Group'){
        console.log('link group background', this.link.site, this.link.description)
        bg = this.link.background
      }
      if(this.linkFormatting.backgroundImage){
        // bg= bg + 'BF'
        bg = this.linkFormatting.buttonGlass == false ? bg: bg + 'BF'

      }
      if(this.linkFormatting.clearLinks){
        bg = null
      }
      if(this.link.site === 'Gallery Grid' && this.linkFormatting.floating){
        bg = null
      }
      if(this.link.site === "Section" && this.linkFormatting.floating){
        bg = "unset"
      }
      if(this.link.site === "WNB Ticket" && this.linkFormatting.floating){
        bg = this.link.background
      }
      if(this.user.linkStyling){
        bg = this.user.linkStyling.background
      }
      // console.log('##', bg)
      return bg
    },
    getTextColour() {
      // console.log('getting text color', this.link.site)
      // console.log('#1')
      if (this.link.ForceTextColour) {
        return this.link.color;
      }
  

      if (this.link.background === 'white') {
      // console.log('#2.1')

        this.link.background = '#ffffff';
      } 
      else if(this.user.linkStyling && this.user.linkStyling.color){
        // console.log('has linkstyling')
        return this.user.linkStyling.color
      }
      else if ((this.link.linkGrid) && (this.user.account === 7 || this.user.enableUpgrades) || this.link.site == 'Section') {
      // console.log('#2.2')

        return '#ffffff'
      } 

      else if ((this.linkFormatting.fullColourButtons) && (this.user.account === 7 || this.user.enableUpgrades) || this.link.site == 'Section') {
      // console.log('#2.2')

        const r = parseInt(this.link.background.substr(1, 2), 16);
        const g = parseInt(this.link.background.substr(3, 2), 16);
        const b = parseInt(this.link.background.substr(5, 2), 16);
        const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
        return (yiq >= 128) ? '#000000' : '#ffffff';
      } 
      else {
      // console.log('#3')

        return '#000000';
      }
      
    },
    imageKitCDN: function(){
      // return this.link.imageKitIgnore == true ? this.link.user : this.link.user.replace('https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o','https://ik.imagekit.io/slink/tr:w-'+window.screen.width+',q:75')
      return this.link.user 
    },
    getQuiz: function(){
      // let q = this.link.quiz
      // console.log('getting questions', this.link.quiz)
      for(var x in this.link.quiz){
        this.link.quiz[x].questionNumber = parseInt(x)
      }

      let q = this.link.quiz.filter(s => {
          return s.answered != true ;
        });
        // console.log(q.slice(0))
        let qq = q.slice(0)
        console.log('q',q[0])
        console.log('questions left', q.length)
        this.treasureHuntQuestionsLeft = q.length

        // q[0]['questionNumber'] = 

      return q[0]
    }
  },
  methods:{
    async submitPipedreamForm() {
    try {
      const response = await fetch(this.link.webhookUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(this.formData)
      });

      if (response.ok) {
        this.ga('Slink Click', this.link.site)
        // Show success message in snackbar
        this.snackbarMessage = this.link.successMessage || 'Form submitted successfully!';
        this.$refs.formSnackbar.open();
        // Clear form
        this.formData = {};
      } else {
        throw new Error('Form submission failed');
      }
    } catch (error) {
      // Show error message in snackbar
      this.snackbarMessage = this.link.errorMessage || 'Error submitting form. Please try again.';
      this.$refs.formSnackbar.open();
      console.error('Form submission error:', error);
    }
  },
    sendDataToParent(task, data) {
      console.log('sendDataToParent','task',  task)
      console.log('sendDataToParent', 'data', data)
      // Sample data to send
      // const data = { message: 'Hello from child' };
      // Emitting an event with data7
      const eventData = {'task': task, 'data': data}
      console.log(eventData)
      this.$emit('childEvent', eventData) ;
    },
    openContent: function(title, source, style){
      this.content.title = title
      this.content.source = source
      this.content.style = style
      console.log('###',  this.content.style)
        this.$refs['popoutContent'].open();
    },
    getDebugInfo: function(){
      console.log(top.location)
      console.log(window.top)
return window.top.location
    },
    nftFilter: function(list, query) {
      if(this.nftNumber.length == 4){
       
      this.link.metadata[this.nftNumber].attributes[6] = Number(this.nftNumber) <= 100 ? true : false
      let totalNFTs = 1493

      console.log('coreape', this.link.metadata[this.nftNumber].attributes)
      console.log('total number of coreapes saved: ', Object.keys(this.link.metadata).length,'/',totalNFTs)

      let backgrounds = {
        'Bubblegum': 207,
        'Bubblez': 188,
        'Cloudy': 167,
        'Creamy': 176,
        'Matcha Lime': 62,
        'Mellow Yellow': 243,
        'Nebula': 1,
        'Sky Blue': 223,
        'Tangerine': 226
      }

      let skins = {
        'Blanco': 105,
        'Brownee': 176,
        'Diamond': 60,
        'Drippy pink': 98,
        'Gold': 9,
        'Green Coreum Fur': 119,
        'Gummy': 110,
        'I Am Root': 116,
        'Inferno': 104,
        'Metallic': 85,
        'Midnight': 106,
        'Phoenix': 79,
        'Radioactive': 103,
        'Syrup': 87,
        'Trippy Eyez': 63,
        'X Ray': 73
      }

      let outfits = {
        'Beez': 63,
        'Black Cult Robe': 36,
        'Blue Ripped Tee': 58,
        'Blue Striped Tee': 72,
        'Blue Tanky': 67,
        'Blue Varsity': 53,
        'Coreum hoodie': 64,
        'Dark Trippy Puffer': 46,
        'Gold Cult Robe': 22,
        'Gold Scarf': 53,
        'Green Scarf': 68,
        'Jade Headphonez': 55,
        'Kimono': 51,
        'Maroon Ripped Tee': 61,
        'Metallic Cult Robe': 30,
        'Naked': 60,
        'Overallz': 38,
        'Purple Varsity': 66,
        'Red Scarf': 55,
        'Suspenders': 29,
        'Tangy Headphonez': 55,
        'Trippy Kimono': 64,
        'Trippy Puffer': 42,
        'Trippy Space Suit': 49,
        'Tye dye': 55,
        'Web3 Geek': 75,
        'White Coreum Hoodie': 55,
        'Windbreaker': 51
      }

      let eyes = {
        '3D Glasses': 28,
        'Aviatorz': 46,
        'Blue Eye Glasses': 57,
        'Blue Eyes': 94,
        'Blue Laser': 66,
        'Coreum Laser': 96,
        'Eye Glasses Swirl': 65,
        'Flamez': 58,
        'Flower Shadez': 75,
        'Gold Shades': 28,
        'Green Eye Glasses': 56,
        'Green Eyes': 83,
        'Green Swirl': 58,
        'Los Muertos': 56,
        'Nuclear Eyes': 70,
        'Orange Slices': 48,
        'Pit Vipers': 26,
        'Rabid': 58,
        'Rainbow Shadez': 33,
        'Red Alert': 65,
        'Scuba': 37,
        'Squint': 55,
        'Static': 60,
        'Third Eye': 75,
        'VR': 15,
        'Wired': 85
      }

      let headwears = {
        '#1': 1,
        'Banana Split': 108,
        'Black Snapback ': 113,
        'Blue Beanie': 113,
        'Brain Matter': 105,
        'Gold Coreum Cap': 46,
        'Green Training band': 94,
        'Mad Hatter': 48,
        'None': 247,
        'Pooty Cap': 126,
        'Solar System': 99,
        'Trippy Beanie': 113,
        'Trippy Cowboy': 57,
        'Trippy Training Band': 88,
        'Trippy Turd': 87,
        'Trippy Viking': 48
      }

      let mouths = {
        '8 Ball': 83,
        'Bubble Pop': 103,
        'Cigarette': 80,
        'Diamond Grill': 44,
        'Drool': 78,
        'Fangz': 74,
        'Forced Smile': 97,
        'Gold Grill': 49,
        'Pizza': 93,
        'Quiet': 84,
        'Rainbow Drool': 69,
        'Rainbow Grill': 26,
        'Rainbow Vomit': 54,
        'Shout': 75,
        'Shroomz': 32,
        'Smiles': 68,
        'Snarl': 83,
        'Trippy Tab': 77,
        'Yawn': 62,
        'Yuck': 93,
        'Yummy': 69
      }
      // console.log('is OG', og)
      // let rarity = 0
      let rarity = this.link.metadata[this.nftNumber].attributes[6] ? (1/100/1470) : (1/(totalNFTs - 100)/totalNFTs)
      rarity = rarity + (1 / (Number(backgrounds[this.link.metadata[this.nftNumber].attributes[0].value])) / totalNFTs)
      rarity = rarity + (1 / (Number(skins[this.link.metadata[this.nftNumber].attributes[1].value])) / totalNFTs)
      rarity = rarity + (1 / (Number(outfits[this.link.metadata[this.nftNumber].attributes[2].value])) / totalNFTs)
      rarity = rarity + (1 / (Number(eyes[this.link.metadata[this.nftNumber].attributes[3].value])) / totalNFTs)
      rarity = rarity + (1 / (Number(headwears[this.link.metadata[this.nftNumber].attributes[4].value])) / totalNFTs)
      rarity = rarity + (1 / (Number(mouths[this.link.metadata[this.nftNumber].attributes[5].value])) / totalNFTs)
      // rarity = rarity + Number(skin[this.link.metadata[this.nftNumber].attributes[1].value])

      rarity = rarity * 100000
      this.link.metadata[this.nftNumber].rarity = Number(rarity)
    }
      // this.link.metadata[this.nftNumber].attributes[0].rarity = backgrounds[this.link.metadata[this.nftNumber].attributes[0].value]
      // console.log(this.link.metadata[this.nftNumber].attributes[0].rarity)
      // this.rarity[this.link.metadata[this.nftNumber].attributes[0].value] = backgrounds[this.link.metadata[this.nftNumber].attributes[0].value]
    
//       var arr = [];
// console.log('test')
//       for(var i = 0; i < list.length; i++) {
//         if(list[i].name.indexOf(query) !== -1)
//           arr.push(list[i]);

//         if(arr.length > 5)
//           break;
//       }

//       return arr;
    },
    isEmail(email){
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\.[a-zA-Z]{2,})?$/;
      console.log('isEmail', emailRegex.test(email), '#')
      return (!emailRegex.test(email) && (email != undefined));
    },
    isMobileNumber(number){
      // console.log('isEmail',email)
      const phoneRegex = /^07\d{9}$/;
      console.log('isPhone', phoneRegex.test(number))
      return (!phoneRegex.test(number) && (number != undefined));
    },
    playScratchCard(){
      scratch = true
      localStorage.setItem('game_'+self.$route.params.collected,true)
    },
    toggleQR(){
      this.ticketQRToggle = !this.ticketQRToggle
      console.log('toggleQR', this.ticketQRToggle)
    },
    prizeClaimed(){
      this.prize.completed = true
      console.log('prize claimed',this.prize.completed, this.LS.game.uid)
      const player = this.LS.game.uid
      if(this.prize.player == undefined){
        var isoDateString = new Date().toISOString();
        // console.log(isoDateString);
        db.ref('tickets/'+ this.$route.params.uid +'/'+ this.prize['.key']).update({ 'played': true, 'player': player, 'playedDate': isoDateString})
        this.$ga.event({
          eventCategory: this.user.url,
          eventAction: 'Scratchcard Played',
          eventLabel: this.prize.id,
        });
      }
    },
    getImageHeight(id){
      // console.log('getImageHeight', id,this.link.aspectRatio )
      this.$nextTick(() => {
        if(this.link.aspectRatio){
          let dimensions = this.link.aspectRatio.split("/") 
          this.arHeight = document.getElementById(id).clientWidth / dimensions[0] * dimensions[1]
          // this.arHeight = 150 / dimensions[0] * dimensions[1]
          // console.log(document.getElementById(id).clientWidth, this.arHeight)
        }
      })
      return this.arHeight+'px !important'
    },
    resetRand(){
      localStorage.removeItem("ticket");;
    },
    getTipsCheckout(tip){
      let checkout = 'https://us-central1-slink-64a53.cloudfunctions.net/getTipsCheckout?' +'p=' + tip + '&u='+ this.user.url + '&c=' + this.user.connectID
        // console.log(checkout)
        window.open(checkout)
    },
    reloadPage(){
      this.$router.go()
    },
    correctTreasureHunt(id, question, status, answer){
      let thCookie = JSON.parse(localStorage.getItem("treasureHunt"))
      if(thCookie == null){
        thCookie = {}
      }

      console.log(thCookie)
      // thCookie['treasureHuntID'] = id

      // let th = {'treasureHuntID': id}
      thCookie[question] = status
      console.log('setting question', thCookie)
      localStorage.setItem("treasureHunt", JSON.stringify(thCookie));
      // alert("Hello! I am an alert box!!");
      console.log('treasureHuntAnswer', status)
      this.treasureHuntAnswer = status == true ? status : false

      if(status){
      this.treasureHuntQuestionsLeft = this.treasureHuntQuestionsLeft - 1
        
        // alert("Correct answer, find more clues to answer more questions");
      }
      else{
        // alert("Wrong answer, try again!");
      }
      if (this.treasureHuntQuestionsLeft == 0){

        this.emailCollection.name = 'Martian'
      console.log('questions left', this.treasureHuntQuestionsLeft, answer, this.emailCollection.name)

      try{
        this.collectEmail()
      }
      catch(e){}
      this.treasureHuntQuestionsLeft == -1

      }
    },
    
    setActiveMedia: function(status){
      this.activeMedia = !status
      if (this.activeMedia){
        this.ga('Slink Click', this.link.site)
      }
    },
    openPasswordPrompt(ref) {
      this.passwordPrompt.title = this.link.site
      this.passwordPrompt.message = 'Enter your details....'
      // console.log('pp', this.passwordPrompt)

      this.$refs['passwordPrompt'].open();

      // this.$refs[ref].open();
    },
    closeDialog(ref) {
      this.$refs[ref].close();
    },
    openQRDialog(title, base, details, suffix, usage){
      event.stopPropagation();
      let link = base + details.trim() + suffix;
      this.qrcode.title = title
      if(usage == 'Spotify'){
        console.log('spotify uri', link)
        //code for scannable spotify link
        this.qrcode.contentHtml = '<div style="width:100%; text-align:center;top: 1vh;position: sticky;"><img src="https://api.qrserver.com/v1/create-qr-code/?data='+ link +'" style="max-width:300px; width: 90%; padding: 10px; background: white; border-radius: 20px;"><p style="padding-top:20px"></div>'

      }
      else{
        this.qrcode.contentHtml = '<div style="width:100%; text-align:center;top: 1vh;position: sticky;"><img src="https://api.qrserver.com/v1/create-qr-code/?data='+ link +'" style="max-width:300px; width: 90%; padding: 10px; background: white; border-radius: 20px;"><p style="padding-top:20px"></div>'
      }
      this.$refs['qrcodeDialog'].open();
    },
    checkPassword:function(){
      if(this.link.password == this.linkPassword){
        this.$refs['passwordPrompt'].close();
        this.openLink()
      }
    },
    collectEmail:function(){
      // this.link.storeEmail = this.link.storeEmail == undefined ? false : this.link.storeEmail


      // console.log('storeEmail', this.link.storeEmail)
      if(this.emailCollection.name && this.emailCollection.email){
        // console.log('collectEmail', this.emailCollection.name, this.emailCollection.email)
        let destinationEmail = this.user.email
        if(this.link.site == 'Email Capture'){
          destinationEmail = this.link.emailCaptureDestination
        }
        destinationEmail = this.link.emailCaptureDestination != undefined ?  this.link.emailCaptureDestination : destinationEmail
          // console.log(destinationEmail)


        // if(this.link.storeEmail == false){

        
          var payload = {
            email: destinationEmail,
            template: 2597607,
            subject: 'New Collected Email',
            variables:{
              collectedName: this.emailCollection.name,
              collectedEmail: this.emailCollection.email,
              collectedLink: this.link.site
            }
          };
          var data = new FormData();
          data.append( "json", JSON.stringify( payload ) );
          fetch("../api/notificationEmail",
          {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
            credentials: "same-origin",
            mode: "no-cors",
            method: "POST",
            body: JSON.stringify( payload )
          })
          // .then(res => res.json())
          .then(res => console.log(res));
        // }
        // else{
          const timestamp = Date.now();
const date = new Date(timestamp);
const options = { day: '2-digit', month: 'short', year: 'numeric' };
const formattedDate = date.toLocaleDateString('en-US', options);
          db.ref('users/'+ this.user.key +'/collectedEmails').push({name:this.emailCollection.name, email:this.emailCollection.email, timestamp: formattedDate});
      // updateClicksRef.transaction(function (current_value) {
      //   return (current_value || 0) + 1;
      // });
        // }
          if(this.link.site == "Email Capture"){
            this.notification = 'Thank you for subscribing!';
            this.$refs.linkNotifications.open();
            this.emailCollection.name = null
            this.emailCollection.email = null
          }
          else if(this.link.site == 'Treasure Hunt'){
            this.notification = 'Thank you for entering!';
            this.$refs.linkNotifications.open();
            this.emailCollection.name = null
            this.emailCollection.email = null
            this.treasureHuntQuestionsLeft = 'emailcollected'
            console.log('emailcollected, ', this.treasureHuntQuestionsLeft)
          }
          else{
            try{this.$refs['passwordPrompt'].close();
            this.openLink()
            }catch(e){}
          }
        
      }
    },
    scratchCardDataCollection:function(scratchCardData){
      console.log('scratchCardData', scratchCardData)
      const timestamp = Date.now();
      const date = new Date(timestamp);
      const options = { day: '2-digit', month: 'short', year: 'numeric' };
      const formattedDate = date.toLocaleDateString('en-US', options);
      db.ref('users/'+ this.user.key +'/scratchcardData').push(scratchCardData);
      this.notification = 'Thank you for subscribing!';
      this.$refs.linkNotifications.open();
      console.log(this.LS.game)
      this.LS.game.collected = true
      localStorage.setItem('game_'+this.$route.params.uid,JSON.stringify(this.LS.game))
      this.LS.game = JSON.parse(localStorage.getItem('game_'+this.$route.params.uid));

    },
    openLink:function() {
      console.log('openLink #1', this.link.site)
      if(this.link.site == 'OnlyFans' && (document.referrer === "https://www.tiktok.com/" || document.referrer === 'http://localhost:8080/superadmin')){
        this.link.tiktokSafe = true
      }
      if(this.link.copyOnly || this.link.tiktokSafe){
        // console.log('copying link')
        let linkToCopy = this.link.base + this.link.user.trim() + this.link.suffix
        this.$clipboard(linkToCopy);
        this.notification = 'Link details copied!';
        this.$refs.linkNotifications.open();
        if(this.link.tiktokSafe){
          event.stopPropagation();
          this.$refs['tiktokDialog'].open();
        }
        this.ga('Slink Click - Copy', this.link.site)
        return
      }
      if(this.link.site == 'Download'){
        console.log('download tings')
      }
      if((this.link.passwordEmail && (!this.emailCollection.name || !this.emailCollection.email)) || (this.link.password && this.link.password != this.linkPassword)){
        this.openPasswordPrompt()
        return
      }
      if (this.link.password == undefined){
        this.link.password = null
      }
      if(this.user.warning != true && (!this.link.password || (this.link.password == this.linkPassword) || (this.link.passwordEmail && this.emailCollection.name && this.emailCollection.email) && (!this.linkFormatting.media || this.link.site == 'Image'))){
        let linkToOpen = null
        if((this.link.site == 'Image' || this.link.site == 'Video Player') && this.link.imageLink != undefined){
          linkToOpen = this.link.imageLink
        }
        else if((this.link.site == 'Image' || this.link.site == 'Video Player') && this.link.imageLink == undefined){
          return
        }
        else{
          linkToOpen = this.link.base + this.link.user.trim() + this.link.suffix
        }

        linkToOpen = ((this.link.base != 'QR Code') && (linkToOpen.indexOf(":") == -1)) ? linkToOpen = "https://" + linkToOpen : linkToOpen

        if (this.link.altLink != undefined && (Math.floor(Math.random() * 3) + 1 == 3)){
          linkToOpen = this.link.altLink
        }

        if((linkToOpen.indexOf("mailto:") != -1 || linkToOpen.indexOf("tel:") != -1)) {
          window.location.assign(linkToOpen);
        }
        // else if(this.link.site === 'YouTube'){
        //   console.log("this is a youtube link")
        //   window.location = "vnd.youtube://www.youtube.com/watch?v=hnGMrufC3vM";
        //   window.location = "tg://msg?to=+56987654321&text=Hello+World!"
        // }
        else{
          linkToOpen = linkToOpen.replace('https://www.onlyfans.com', 'https://onlyfans.com')
          // linkToOpen = linkToOpen.replace('www.onlyfans.com','onlyfans.com')
          window.open(linkToOpen);
        }
        let gaLabel  =((this.link.site == "Image" || this.link.site == "Video Player") && this.link.gaLabel != undefined) ? this.link.site +' ' + this.link.gaLabel: this.link.site
        this.ga('slink_click', gaLabel)
        analytics.logEvent("link_click", {'site':gaLabel, 'link': linkToOpen, 'adult': this.link.adult, 'altLink': this.link.altLink});
      }
      
    },
    openCarouselLink:function(imageURL, imageID, linkID){
      console.log('opening link')
      if(imageURL){
        this.ga('slink_click', this.link.site, linkID + '/'+'images/'+imageID)
        window.open(imageURL);
      }
    },
    // openGalleryLink:function(openLink) { //redunant
    //   console.log('openGalleryLink', this.link, openLink)
    //   if(this.user.warning != true && (this.link.password == this.linkPassword)){
    //     if (openLink != "undefined"  && this.link.base != 'QR Code') {
    //       openLink = (openLink.indexOf(":") == -1) ? openLink = "http://" + openLink : openLink
    //       this.ga('slink_click', this.link.site)
    //       window.open(openLink);
    //     }
    //   }
    // },
    ga:function(action, label, imagePath) {
      // console.log('ga',event)
      this.$ga.event({
        eventCategory: this.user.url,
        eventAction: action,
        eventLabel: label,
      });
      // console.log('ga', this.user.url, action, label )

      if(this.user.fbPixel){
        // window.fbq.push('track', 'Slink Click', {value: 1.00, site: this.link.site});
      }
      const path = imagePath ? imagePath : this.link.id
      var updateClicksRef =  db.ref('users/'+ this.user.key +'/links/'+ path +'/clicks');
      updateClicksRef.transaction(function (current_value) {
        return (current_value || 0) + 1;
      });
    },
    vote:function(team){
      var updateClicksRef =  db.ref('users/'+ this.user.key +'/links/'+ this.link.id +'/' + team +'/votes');
      updateClicksRef.transaction(function (current_value) {
        return (current_value || 0) + 1;
      });
    },
  },
  mounted () {

    if (this.link && this.link.fa && this.link.fa.includes('youtube-play')) {
    this.link.fa = this.link.fa.replace('youtube-play', 'youtube')
  }
    // if(this.link.site == 'Carousel' && this.link.autoslide){
    // console.log('created', this.link.site)

    //   let autoslider = document.getElementById('autoslider');
    //   // console.log('#duration', autoslider.style)
    //   let numberOfImages = Object.keys(this.link.images).length * 2
    //   let numberOfGaps = numberOfImages - 1
    //   let imgWidth = this.link.imgWidth
    //   let totalWidth = (numberOfImages * imgWidth) + (numberOfGaps * 10)
    //   let duration = totalWidth / 100 * 50
    //   console.log('no images', totalWidth / 100 * 50)
    //   autoslider.style.animationDuration = duration + 's';

    // }
    //   let root = document.documentElement;
    //   let duration = link.autoslide ? '10s' : link.autoslide + 's'
    //   root.style.setProperty('--autoslide-animation-duration', duration);
    // }
    
    // console.log(user)
    // console.log('linkComponent', this.li)
    // console.log('linkComponent', this.user)
    // console.log('linkcomponent', this.link.site)
    // if(this.link.site == 'KissOrSlap'){
    //   this.$nextTick(() => {
    //   console.log('started')
    //   let self = this
    //   setTimeout(function () {
    //     console.log('1', 'kissorslap', randBoolean)
    //     let randBoolean = Math.random() < 0.5;
    //   console.log('KISSORSLAP', randBoolean)
    //   self.link.kissorslap = randBoolean ? 'Kiss' : 'Slap'
    //   console.log(self.link.kissorslap)
        
    // }, 5000);
    //   })
    // }
    
  	  // console.log('LinkComponent', this.link.site)
      // if(this.link.site == 'YouTube Player'){
      // console.table([{'site':this.link.site, 'id':this.link.id}])

      // }
    
  }
}
</script>

// Our styling will go here
<style>

:root {
    --slideDuration: 60s;
  }
/* .html, .body, .slinksContainer.fullScreen, .slinkItems, .slinkItems .link{
  height: 100%;
    display: flex !important;
    flex-direction: column;
} */
img{
  /* pointer-events: none; */
}

.link.style3.compact summary .container{
  grid-template-columns: auto 40px !important;
  padding-left:40px;
  text-align:center;
}
#Section{
  /* box-shadow:unset; */
  height:unset;
  font-weight:bold;;
  /* padding-top:16px */
  /* text-transform: uppercase; */
}
#Section .link.compact .link{
  grid-template-columns: unset;
  padding:8px;
  /* padding-right:8px; */
  min-height:unset;
}

/* #Section .link .link .text{ */
  /* padding-top:32px; */
/* } */

#Section .link.compact .link .text .title{
  font-size:20px !important ;
  text-align: center;
  /* padding-top:16px; */

}

.treasureHunt{
  padding:8px;
  display:flex;
  flex-direction:column;
  gap:10px;
}

.treasureHunt .task{
  border:1px silver solid;
  /* padding:4px 8px; */
  border-radius:5px;
  /* font-weight:bold; */
}

.treasureHunt .task .question{
  border-bottom: 1px silver solid;
  padding:8px 8px;
  /* border-radius:5px; */
  font-weight:bold;
  font-size:medium;
  background:whitesmoke
}

.treasureHunt .task .answers{
  display:flex;
  flex-direction: column;
  /* border-bottom: 1px silver solid; */
  padding:8px 4px;
  /* border-radius:5px; */
  font-weight:bold;
  font-size:medium;
}

.treasureHunt .task .result{
  text-align: center;
  font-weight:900;
  font-size: xx-large;
  padding:40px 10px;
  background:#f5f5f5;
  color:#000000;
  border:1px solid silver;
  margin:0 12px 10px;
  border-radius:5px;
  height:100px
}

.treasureHunt .task .result.unanswered{
  /* content:"CLUE"
   */
   font-size:medium;
   padding: 30px
}


div#Gallery\ Grid.linkBorder {
    border: unset;
}
/* .slinksContainer{
  padding:20px;
  width:100%;
  min-height:56px;
  display:grid;
}

.slinksContainer.floating{
  gap: 10px;
}

.slinksContainer.notFloating *:first-child{
  border-radius: 10px 10px 0px 0px
}

.slinksContainer.notFloating *:last-child{
  border-radius: 0px 0px 10px 10px
} */

/* start of new */
/* .link.style0, .link.style0, .link.style0 { */
  /* box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 5px 8px rgba(0, 0, 0, 0.14), 0 1px 14px rgba(0, 0, 0, 0.12); */
/* } */

.link .link{
  width:100%;
  min-height:80px;
  overflow:hidden;
  /* background:white; */
  display:grid;
  grid-template-columns: 80px auto;
  gap:12px;
}

.link .link.qrcode{
  grid-template-columns: 80px auto 40px !important;
}

.link.compact .link.qrcode{
  grid-template-columns: 56px auto 40px !important;
}
/* .link .link.compact{
  grid-template-columns: 56px auto 40px;
  min-height:56px;
} */

.groupNoIcon{
  grid-template-columns: auto !important;
  padding-left:10px;
}

.imageHeader{
  padding:unset !important
}

.link.compact .link{
  grid-template-columns: 56px calc(100% - 56px - 12px - 8px);
  /* grid-template-columns: 56px auto 40px; */
  min-height:56px;
}

.link.compact .container{
  min-height:56px !important
}
/* 
.link .link.floating{
    border-radius:10px;
} */

.link .link .icon{
  width: 56px;
  width:100%;
  aspect-ratio: 1/1;
  justify-content: center;
    align-items: center;
    display: -webkit-inline-box;
    padding:8px;
}

.link.style2 .icon{
  padding:unset;
  display:flex
}

.link.style2.groupMember .link .icon .siteicon{
  padding:unset !important;
}

.groupMemberGallery{
  box-shadow:unset
}

summary div .icon .siteicon.style2{
  padding:unset !important
}

.inLineGroup.groupNoIcon{
  /* padding-left:unset */
  padding-right:10px
}


.groupMember .galleryGrid{
  margin:10px;
}
/* .style0 .link .icon img{
  border-radius:50%;
  box-shadow: 0 1px 5px rgb(0 0 0 / 20%), 0 2px 2px rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%);
} */

/* .siteicon .style1 .md-avatar{
  border-radius:7px;
  box-shadow: 0 1px 5px rgb(0 0 0 / 20%), 0 2px 2px rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%);
} */

/* .style1 .icon img{
  border-radius:7px;
  box-shadow: 0 1px 5px rgb(0 0 0 / 20%), 0 2px 2px rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%);
} */


/* .style2 .icon{
  border-right:1px solid #f5f5f555
}

.style2 .icon img{
  border-radius:50%;
  box-shadow: 0 1px 5px rgb(0 0 0 / 20%), 0 2px 2px rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%);
} */

.kissorslap{
  display:flex;
  margin:auto;
  width:100%;
  /* padding: 60px 30px; */
    aspect-ratio: 3/2;
    background: black;
    /* font-weight: 900; */
    font-size: 50px;
    text-align: center;
    
    color: white;
  /* transform: scale(0.94); */

  /* animation: scale 3s forwards cubic-bezier(0.5, 1, 0.89, 1);  */

}

.kissorslap .placeholder{
  margin:auto;
  /* padding: 40px; */
  animation: cssAnimation 0s ease-in 2s forwards;
  background:#000000;
  width:100%;
  position:absolute;
  height:100%
}

.kissorslap .placeholder .md-theme-default.md-spinner .md-spinner-path{
  stroke: #ffffff

}

.kissorslap .placeholder .md-theme-default.md-spinner{
  height:100% !important;
}


.kissorslap .result{
  margin:auto;
  text-transform: uppercase;
  font-size: 100px;
  padding: 30px;
  width: 100%;
  /* animation: cssAnimation 0s ease-in 3s forwards; */

}

.kissorslap .restart{
  position: absolute;
    bottom: 0px;
    right: 0;
    border-top: 2px solid white;
    border-left: 2px solid white;
    border-radius: 10px 0;
    padding: 5px;
}

@keyframes cssAnimation {
    to {
        /* width:0; */
        /* height:0; */
        /* overflow:hidden; */
        /* visibility:hidden; */
        /* display:none; */
        z-index:-1
    }
}

@keyframes scale {
  100% {
    transform: scale(1);
  }
}
.link .link .text{
  padding: 8px 0px;
  align-content: center;
  display: grid; 
  width:100%; 
}

#Section .link .link{
  /* padding: 8px 0px;
  align-content: center;
  display: grid; 
  width:100%;  */
  min-height: unset;
  font-size: larger;
}

#Section .link .link .text .title{
  /* padding: 8px 0px;
  align-content: center;
  display: grid; 
  width:100%;  */
  /* min-height: unset; */
  font-size: 24px;
}

/* .link.compact .link .text{
  padding-top:8px;
  padding-bottom:8px;
  align-items: center;
  display: grid; 
  width:100%; 
} */

.link .link .text .title{
  font-weight:bold; 
  font-size:16px;
}

.floating .link{
  border-radius:10px;
  overflow:hidden;
  /* display:none */
}

/* .shake{
  animation: shake 2.0s;
  animation-iteration-count: infinite;
}

@keyframes shake {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
} */

/* details{
  padding: 8px 0px 8px 8px;
} */

/* .link.style0 .container{
  grid-template-columns: 56px auto 40px !important;
} */

.link.style0.compact details summary .container .icon{
  padding:unset;
}

.link.style0.compact details summary .container {
  grid-template-columns: 56px auto 40px !important;
  /* padding:unset; */
}

.link.style1 details summary .container{
  padding:8px;
}

.link.style1.compact details summary .container{
  padding:unset;
}

.link.style2 details{
  padding:unset
}

.link.style1 details summary .text{
  padding-left: 16px !important;
}

.link.style1.compact.groupMember .link .icon{
  padding:unset !important;
}

.link.style1 details summary div .icon{
  padding:unset !important;
}

.link.style1.compact summary div .text{
  padding-left:unset !important;
}

/* .link.style2.groupMember { */
  /* grid-template-columns: 80px auto 40px !important; */
  /* padding:unset; */
/* } */

.link.style3 .link{
  grid-template-columns: 100%;
  /* grid-row-start: 2; */
  justify-content:center;
  text-align:center;
  display:flex;
}

.link.style3 details summary .container{
  grid-template-columns: auto !important;
  justify-content:center;
  text-align:center;
  /* background:pink; */
}

.link.style3 .link.qrcode button{
  display:none;
}

.link.style3.groupMember .link{
  width:100%;
}

.link.style3 .link .icon{
  display:none;
}

.link.style3 details summary .container .icon{
  display:none;
}

details summary .text{
  padding-left: 16px;
}

summary:active {
    border:none;
}

.compact details{
  padding:unset !important;
}

/* .compact details summary .text{
  padding: unset !important;
} */

details>summary {
  list-style: none;
}

summary::-webkit-details-marker {
  display: none
}

details summary > * {
  display: inline !important;
}

.style2 details summary .container{
  grid-template-columns: 80px auto 40px !important;
}

.style2.compact details summary .container{
  grid-template-columns: 56px auto 40px !important;
}
details summary .container .text{
  padding-left:unset;
}

/* summary::after {
  width: 24px;
  min-width: 24px;
  min-height: 24px;
  font-size: 24px;
  font-family: 'Material Icons';
  content: '\e5cf';
  display:flex;
  justify-content: center;
  align-items: center;
  position:absolute;
  top:16px;
  right:12px;
} */

/* details summary > * {
  display: inline;
} */

/* details[open] summary:after {
  content: "\e5ce";
} */

.link.style2 .icon{
  height:100%;
  box-shadow: 0 1px 5px rgb(0 0 0 / 20%), 0 2px 2px rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%);
  width:100%;
}

/* .link.style2 .icon{
  height:100%;
  box-shadow: 0 1px 5px rgb(0 0 0 / 20%), 0 2px 2px rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%);

} */

.link.style2.icon .siteicon{
  /* height:100%; */
  box-shadow: unset !important;
  position:relative;
  top:0px;

  
}


/* .slinksContainer .link, .slinksContainer .links{
  box-shadow:   0 3px 5px -1px rgb(0 0 0 / 20%), 0 5px 8px rgb(0 0 0 / 14%), 0 1px 14px rgb(0 0 0 / 12%);
} */























/* .md-list-item-expand .md-list-expand{ */
  /* width:100% */
/* } */

.TikTokPlayer .md-list-expand, .TikTokPlayer iframe, iframe.TikTokPlayer{
  width:100%;
  aspect-ratio: 346/710;
}

/* .InstagramPost, .InstagramPost .md-list-expand{
  width:100% !important;
} */

/* .instagram-media, iframe.InstagramPost{
  width:100% !important;
  aspect-ratio: 353.6/600;
  margin:0px !important;
} */

iframe.Ko-fiDonation{
  height:550px !important
}

/* iframe.GumroadProduct{ */
  /* height:600px !important */
/* } */

iframe.TikTokPlayer{
  margin-bottom: -100px;
}

/* .ar16-9, .YouTubePlayer .md-list-expand, .YouTubePlayer iframe{
  width:100%;
  aspect-ratio: 16/9;
} */

.protectedImage{
  filter:blur(10px)
}
.popoutContent .md-dialog{
  width:95vw;
  max-width:500px;
}

.passwordPrompt .md-dialog{
  border-radius:10px;
  width:calc(100vw - 40px);
  max-width:350px;
}

.passwordPrompt .md-dialog .md-dialog-title{
  display:flex;
  max-height: 48px;
  font-weight: bold;
  line-height: 40px;
  padding: 5px 20px;
  margin-bottom: 0px;
  border-bottom: solid 1px silver;
}
.passwordPrompt .md-dialog .md-dialog-content{
  padding: 10px 20px;
}

</style>
<style scoped>

figcaption.overlay{
  position: absolute;
  bottom:0;
  color:#ffffff;
  font-size:x-large !important;
  width:100%;
  /* text-align: center; */
}

figcaption.overlay div{
  font-size:18px !important;
  padding:5px;
}

 .textOverlay{
    opacity: 0.75;
    width: 100%;
    height: 100%;
    top: 0px;
    position: absolute;
    text-align: center;
    display: flex;
    justify-content: center;
    justify-items: center;
    align-items: center;
    color: #ffffff;
    font-weight: 900;
    font-size: 30px;
    letter-spacing: 10px;
    margin-left: 10px;
    text-shadow: 1px 0 2px black, 0 1px 2px black, -1px 0 2px black, 0 -1px 2px black;
 }

.tipButton{
  /* margin: 4px;
    border: 1px solid silver;
    border-radius: 7px;
    padding: 10px;
    width: 100%;
    justify-content: center;
    align-content: center;
    align-items: center;
    justify-self: center;
    text-align: center; */
    font-size: 16px;
    font-weight: bold;
    margin: unset;
    border-radius: 7px;
    padding: unset;
    min-width: unset;
    width: 100%;
    aspect-ratio: 4/3;
    background:#7DB6A844 !important;
    border-color: #7DB6A855;
    border: 1px solid; 
}

.md-list-item-expand .md-list-expand{
  width:100%
}

.videoBox .player .finishCover{
  display:none !important
}

.link{
  width:100%
}
.standardLink .md-list-text-container{
  margin-top:8px; 
  margin-bottom:8px
}

.textAlign{
  text-align:center;
  padding-left:16px;
}

h3{
  white-space: normal; margin:unset
}

h3 span{
  white-space: inherit;
}

/* .tiktokPlayer{
  width:100%;
  aspect-ratio: 18/41
} */



/* .compactLinks .md-list-item-container md-button{
  min-height:56px
} */

@keyframes autoslider {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
}

.carousel.autoslide{
  animation: autoslider 36s infinite linear;
  /* overflow: unset;
  width:100%; */
  overflow: visible;
    width: max-content;
    /* border:3px solid red */
}

.carousel.autoslide:hover{
  animation-play-state: paused;
}
.autoslideFade{
position:absolute;
background: linear-gradient(90deg, #1e293b, transparent 30%, transparent 70% #1e293b);
inset: 0;
pointer-events: none;
}
.carousel{
  padding:10px 10px;
  /* border-radius:10px; */
  background:white;
  display: flex;
  overflow-x: scroll;
  gap: 10px;
}

.carousel figure{
  z-index: 0;transform: translateZ(0);
  height: fit-content;
  border-radius:7px;
  overflow:hidden;
  margin:unset;
  /* width: 150px; */
  /* flex-basis: 150px; */
  flex-grow: 0;
  flex-shrink: 0;
  box-shadow: 0 3px 5px -1px rgb(0 0 0 / 20%), 0 5px 8px rgb(0 0 0 / 14%), 0 1px 14px rgb(0 0 0 / 12%);
}

.carousel figure img{
  width: 150px;
  object-fit: cover;
  object-position: center;
  pointer-events: none;
}

.carousel figure figcaption{
  /* padding:5px 10px; */
  margin:5px;
  font-weight:bold;
}

.personalStats{
  width:100%; 
  font-size:initial;
  /* display:grid; */
  /* grid-template-columns: 50% 50%; */
}

.personalStats .row{
  display:grid;
  grid-template-columns: 30% 70%;
  width:100%;
  padding:8px 16px;;
  background:#ffffff;
  text-transform:capitalize; 
}

.personalStats .row:nth-child(even){
  background:#f0f0f0
}

.personalStats .row .header{
  font-weight:bold;
  white-space: nowrap;
}

.galleryGrid{
  display: grid;
  grid-template-columns: calc(50% - 5px) calc(50% - 5px);
  /* padding:10px; */
  gap:10px;
  box-shadow:unset;
  /* padding:5px 5px 10px 5px */
  overflow:visible;
  
}

.galleryGrid.caption_{
padding:10px;
background:white;
box-shadow: 0 3px 5px -1px rgb(0 0 0 / 20%), 0 5px 8px rgb(0 0 0 / 14%), 0 1px 14px rgb(0 0 0 / 12%);
/* border-radius:10px; */
}

.links.caption{
  border-radius:10px;
}

.galleryGrid.hasLabels{
padding:10px;
background:white;
box-shadow: 0 3px 5px -1px rgb(0 0 0 / 20%), 0 5px 8px rgb(0 0 0 / 14%), 0 1px 14px rgb(0 0 0 / 12%);
}

.galleryGrid figure{
  display:flex;
  flex-flow:column;

  height:100%;
  /* margin:10px;; */
  background:#ffffff;
  margin:unset;
  border-radius:7.5px;
  overflow:hidden;
  /* border:1px solid silver */
  box-shadow: 0 3px 5px -1px rgb(0 0 0 / 20%), 0 5px 8px rgb(0 0 0 / 14%), 0 1px 14px rgb(0 0 0 / 12%);
  

}
.galleryGrid figure img{
  width:100%;

  aspect-ratio:4/3;
  object-fit: cover;
  object-position: center;
  /* border-bottom:1px solid whitesmoke */

}

.galleryGrid figure figcaption{
  flex-grow: 1;
  /* display: flex; */
  /* align-items: center; */
  width:100%;
  /* height:100%; */
  /* display:flex; */
  /* justify-content: center; */
  /* align-items: center; */
  /* margin:5px 5px; */
  padding:5px;
  font-weight:bold
}

.grouped .galleryGrid.col1{
  grid-template-columns: 100%;
  gap:10px;
  /* margin: unset !important; */
}

.galleryGrid.col1 figure{
  display: grid;
    /* grid-template-columns: 125px calc(100% - 125px); */
    /* border-radius:unset; */
}

.galleryGrid.col1 figcaption{
  margin-left:16px;
}

/* .galleryGrid.col1 figure img{ */
  /* aspect-ratio:16/9; */

/* } */

.galleryGrid.col1{
  grid-template-columns: repeat(1,1fr);
}

.galleryGrid.col2{
  grid-template-columns: repeat(2,1fr);
}

.galleryGrid.col3{
  grid-template-columns: repeat(3, minmax(0, 1fr));

}

.galleryGrid.col4{
  grid-template-columns: repeat(4,1fr) ;
}

.galleryGrid.col4 figure figcaption{
  font-size:x-small !important;;
  text-align:center;
}

::-webkit-scrollbar { 
    /* display: none;  Safari and Chrome */
    height:10px;
    
}
::-webkit-scrollbar-thumb {
    background-color: #C3C7C7 ;
    border-radius:50px
}

::-webkit-scrollbar-track {
    /* background-color: orange; */
    margin-left:10px;
    margin-right:10px;
    border-radius:50px;
    background-color: #C3C7C755;
}

/* .grouped .link,  */
.gridItem{
  border-radius:5px !important;

}
.groupMember, .groupMember .link, .imageCaption, .groupMember .content, .groupMember di1v{
  border-radius:unset !important;
  box-shadow: 0 1px 5px rgb(0 0 0 / 20%), 0 2px 2px rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%);
}

.grouped .links.carousel {
    box-shadow: none;
}

.coinmarketcap-currency-widget{
  width:100%
}

.embeds *{
  width:100%
}

.floatingInfo{
  border-radius:10px 0 10px 0 10px
}

.link.style1.compact details summary .container{
  grid-template-columns: 56px auto 40px !important;
  padding:unset;
}

div#Gallery\ Grid.linkBorder {
    border: unset;
}

div#Gallery\ Grid.linkBorder .link .links figure {
    border: unset;
    border: 5px solid black;
    border: 2px solid var(--linkBorder);
    border-radius: 10px;
}

#Gallery\ Grid{
  background: unset;
    overflow: unset;
}




/* Raffle Ticket */
svg {
	position: fixed;
}

#roughpaper {
	opacity: 0.2;
}

.ticket {
	filter: drop-shadow(5px 5px 8px rgba(0, 0, 0, 0.2)) blur(0.2px);
	position: relative;
}

.ticket::after {
	content: "";
	filter: url("#roughpaper");
	clip-path: path(
		"M4.3542 116.355C17.3259 117.282 20.7794 127.838 20.8847 133C91.2186 132.93 235.192 132.79 248.417 132.79C250.733 118.568 264.421 116.04 265.263 115.829C266.106 115.619 265.263 113.512 265.263 112.985C265.263 112.458 263.263 111.931 263.263 110.141C263.263 108.35 264.632 106.875 265.263 106.453C265.895 106.032 265.895 102.872 265.895 102.134C265.895 101.397 262.842 99.7112 262.842 97.7096C262.842 95.708 265.158 94.4438 265.895 91.5994C266.632 88.7551 263.263 87.8069 262.842 84.9626C262.42 82.1182 265.895 82.2235 265.895 79.0631C265.895 75.9027 262.842 76.1134 262.842 73.269C262.842 70.4247 265.369 70.3193 265.895 67.0535C266.421 63.7878 262.842 63.261 262.842 60.522C262.842 57.783 265.369 58.099 265.895 54.4119C266.421 50.7247 262.842 49.9873 262.842 47.9857C262.842 45.9841 265.79 43.2451 265.895 41.8756C265.895 39.5 263.263 38.9258 262.842 36.3975C262.42 33.8692 265.369 32.605 265.369 29.6553C265.369 26.7055 262.526 25.7574 262.526 23.9665C262.315 21.9649 267.369 19.4366 261.999 17.3296C253.66 15.6441 249.259 5.7409 248.101 1H22.6751C22.6751 1 21.7275 1.00095 21.7275 1.63208C17.9371 18.2769 6.77635 17.3286 6.03932 17.3286C5.30229 17.3286 5.51287 16.4859 3.72294 18.3821C1.93301 20.2784 4.3542 22.8067 4.3542 27.3366C4.3542 31.8665 1.61708 33.4467 2.14359 35.027C2.6701 36.6072 4.3542 37.1339 4.3542 40.821C4.3542 44.5082 1.82766 43.3494 1.09063 45.7724C0.353596 48.1954 4.3542 48.5114 4.3542 52.3039C4.3542 56.0964 1.61708 54.0948 1.61708 57.9927C1.61708 61.8905 4.3542 60.3103 4.3542 63.9975C4.3542 67.6846 1.61708 67.6846 1.61708 70.845C1.61708 74.0054 4.3542 74.1108 4.3542 77.1659C4.3542 80.2209 1.61708 79.7995 1.61708 82.3279C1.61708 84.8562 4.3542 86.9632 4.3542 89.1754C4.3542 91.3877 1.61708 92.5466 1.61708 94.8642C1.61708 97.1818 4.3542 100.132 4.3542 101.712C4.3542 103.292 2.03824 106.242 2.03824 108.033C2.03824 109.465 3.23125 111.86 3.82775 112.879C3.82775 113.511 4.35457 114.986 4.3542 116.355Z"
	);
	position: absolute;
	inset: 0;
}

p {
	z-index: 2;
	padding: 0.8rem 1.2rem;
	position: relative;
	font-size: 3rem;
	font-stretch: 85%;
	font-weight: 800;
	text-transform: uppercase;
	text-align: center;
	letter-spacing: -1px;
	display: grid;
	grid-template-columns: auto min-content auto;
	filter: url("#warp");
	mix-blend-mode: multiply;
	transform: scale(0.95) translatex(-6px);
}

span {
	border: 3.5px solid var(--border-color);
	padding: 0 0.75rem;
}

p::after,
p::before {
	content: "123456";
	font-size: 1.8rem;
	font-stretch: 85%;
	font-weight: 400;
	writing-mode: vertical-lr;
	border: 3.5px solid var(--border-color);
	letter-spacing: 1px;
}
p::after {
	border-left: none;
	border-bottom-right-radius: 0.75rem;
	border-top-right-radius: 0.75rem;
}

p::before {
	border-right: none;
	border-bottom-left-radius: 0.75rem;
	border-top-left-radius: 0.75rem;
}

details[open] summary i.more{
  display:none;
}

details[open] summary i.less{
  display:unset;
}

details summary i.less{
  display:none;
}



.scratchcard {
  /* border: 5px solid #069BBC; */
  position: relative;
  /* width: 300px; */
  /* height: 300px; */
  width:100%;
  aspect-ratio:3/2;
  /* margin: 0 auto; */
  margin:unset;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none; 
  -o-user-select: none;
  user-select: none;
}

.scratchcard .canvas {
  position: absolute;
  top: 0;
}

.scratchcard .form {
  padding: 20px;
}

.scratchcard .scratchcard-content .card-content{
  display: flex;
    flex-direction: column;
    height: -webkit-fill-available;
    width: 100%;
    justify-content: center;
    align-items: center;
    font-size:xx-large;
    font-weight:bolder;
    text-align: center;
    line-height: 35px;
    padding:10px;
}

.shake{
  animation: shake 2.0s;
  animation-iteration-count: infinite;
}

@keyframes shake {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}

.ticketQRLarge{
  width:200px !important;
  z-index:10;
  padding:5px; 
}
</style>


// WEBPACK FOOTER //
// src/components/link_component_v2.vue